// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchContainer {
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  min-height: 150px;

}

.searchContainer  > form > select {
    width: 100px;
    height: 50px;
  }

.searchContainer  > form > div {
    width: 300px;
    height: 50px;
    margin-left: 10px;
  }

.searchContainer  > div {
    position: absolute;
    top: 65px;
    right: 0;
    width: auto;
    max-width: 400px;
    max-height: 100px;
    overflow-y: auto;
    padding: 0 6px;
    border-radius: 20px;
  }

:is(.searchContainer > div)  > .search-result-item {
      background-color: var(--fundo);
      padding: 6px 10px;
      cursor: pointer;
    }

:is(:is(.searchContainer > div) > .search-result-item):hover {
        color: var(--texto-destaque);
      }

.searchContainer>* {
  margin: 0;
}

.titulo-children form {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.titulo-children form select {
  width: 100px;
  padding: 10px;
  border: none;
  color: var(--texto);
  background-color: var(--branco);
  margin: 0;
  border: 1px solid var(--texto-destaque);
}

.titulo-children form .status-filter-select {
  width: 190px;
}

.titulo-children form input {
  width: 300px;
  padding: 10px;
  border: none;
  background-color: var(--branco);
  margin: 0;
  border: 1px solid var(--texto-destaque);
}



/* Formulario de cadastrar interno */
.content-register-internal {
  position: relative;
  background-color: var(--branco);
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.register-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 10px 20px 0;
}

.register-step {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f4f6fb;
  border-radius: 12px;
  padding: 10px 14px;
  color: var(--texto-destaque);
  border: 1px solid #e4e8f2;
}

.register-step span {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #d7ddea;
  color: #5b6474;
  font-weight: 600;
}

.register-step p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.register-step.active {
  background: #eef4ff;
  border-color: #c6d7ff;
  color: #1f3b8f;
}

.register-step.active span {
  background: #2f6fed;
  color: #fff;
}

.form-cadastro-interno {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 20px;
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;

}

.form-cadastro-interno .image-upload-container {
  background-color: #f8f9fd;
  border-radius: 10px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
  width: 100%;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--borda);
  cursor: pointer;
  position: relative;
  overflow: hidden;


}

:is(.form-cadastro-interno .image-upload-container)  > input {
    opacity: .3;
    height: 100%;
    width: 100%;
    cursor: pointer;
    z-index: 1;
  }

:is(.form-cadastro-interno .image-upload-container)  > span {
    position: absolute;
    bottom: -40px;
    font-weight: bold;
    color: #292d32b4;
  }

.form-cadastro-interno .image-upload-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-cadastro-interno .image-upload-label {
  font-weight: bold;
  color: #292d32b4;
  margin-left: 10px;
  font-size: 13px;
}

/* Quando a webcam está ativa, o container precisa crescer */
.form-cadastro-interno .image-upload-container.webcam-active {
  height: auto;
  padding: 12px;
  align-items: stretch;
}

.form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam {
  width: 100%;
}

.form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam video {
  max-height: 320px;
  object-fit: cover;
}

.inclusion-step {
  padding: 24px 30px 30px;
}

.inclusion-form .form-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.inclusion-section {
  margin-bottom: 20px;
}

.inclusion-section h5 {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--texto);
  background: #f3f4f6;
  padding: 8px 10px;
  border-radius: 8px;
}

.inclusion-form .form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.inclusion-form label {
  font-size: 13px;
  font-weight: 600;
  color: var(--texto);
}

.inclusion-form input,
.inclusion-form select {
  border: 1px solid var(--borda);
  padding: 8px 10px;
  border-radius: 8px;
  background: var(--branco);
}

.inclusion-form textarea {
  border: 1px solid var(--borda);
  padding: 8px 10px;
  border-radius: 8px;
  background: var(--branco);
  resize: vertical;
}

.inclusion-textarea {
  grid-column: 1 / -1;
}

.inclusion-upload {
  background: #f7f9ff;
  border: 1px dashed #cbd5f5;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.inclusion-upload input[type="file"] {
  margin-top: 10px;
}

.inclusion-upload .image-upload-container {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
  width: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed var(--borda);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  padding: 12px;
}

.inclusion-upload .image-upload-container.webcam-active {
  min-height: unset;
  align-items: stretch;
}

.inclusion-upload .image-upload-container img {
  width: 50px;
  height: 50px;
  opacity: 0.5;
}

.inclusion-upload .image-upload-container .upload-icon {
  position: static;
}

.inclusion-upload .image-upload-container>span {
  color: #292d32b4;
  font-weight: 600;
  text-align: center;
}

.inclusion-upload .image-upload-container .preview-image {
  position: static;
  width: 100% !important;
  height: 100% !important;
  min-height: 190px;
  object-fit: contain;
  border-radius: 10px;
  background: #fff;
}

.inclusion-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.existing-file {
  font-size: 13px;
  margin: 6px 0 0;
}

.form-cadastro-interno .image-upload-container img {
  width: 50px;
  height: 50px;
  opacity: 0.5;
  position: absolute;
  cursor: pointer;
}

.image-preview {
  width: 100%;
  height: 100%;
  max-height: 250px;
  object-fit: cover;
  border-radius: 10px;
}

.image-upload-container .preview-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
  border-radius: 10px;
  position: absolute;
  z-index: 0;
  background: #fff;
}

.form-cadastro-interno .form-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.form-cadastro-interno .form-group div {
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  border-radius: 8px;
}

.form-cadastro-interno .form-group label {
  font-weight: bold;
  color: #292d32b4;
  margin-left: 10px;
  font-size: 13px;
  z-index: 1;
}

.btn-cadastrar-interno {
  position: absolute;
  top: 14px;
  right: 20px;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  padding: 6px 16px;
  border: 1px solid var(--texto-destaque);
  color: var(--texto-destaque);
}

.btn-action-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.btn-cadastrar-interno:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .form-cadastro-interno {
    grid-template-columns: 1fr;
    padding: 20px;
    gap: 15px;
  }

  .form-cadastro-interno .image-upload-container {
    max-width: 300px;
    margin: 0 auto;
    height: 200px;
  }

    :is(.form-cadastro-interno .image-upload-container)  > span {
      margin-bottom: 15px;
    }

  .form-cadastro-interno .image-upload-container.webcam-active {
    max-width: 100%;
    height: auto;
    padding: 12px;
  }

  .form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam video {
    max-height: 220px;
  }

  .form-cadastro-interno .form-group {
    grid-template-columns: 1fr;
  }

  .btn-cadastrar-interno {
    position: static;
    margin-top: 20px;
    width: 100%;
    justify-content: center;
    border: none;
    background-color: var(--texto-destaque);
    color: var(--branco);
    padding: 10px;
    border-radius: 8px;
    font-size: 18px;
  }

  .register-steps {
    grid-template-columns: 1fr;
    padding: 10px 16px;
  }

  .inclusion-form .form-group {
    grid-template-columns: 1fr;
  }

  .inclusion-actions {
    flex-direction: column;
  }

  .image-upload-actions .btn-primary,
  .image-upload-actions .btn-secondary {
    flex: 1 1 140px;
  }
}


/* Container de conduta e regime do editar interno */
.custom-regime-conduct-row {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.custom-select-regime,
.custom-select-conduct {
  flex: 1 1;
  padding: 10px;
}


/* Page internaldetails */
.internal-details {
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  gap: 24px;
}

.internal-details-skeleton {
  padding: 8px 0;
}

.internal-accordion-skeleton {
  padding: 14px 16px;
}

.accordion-empty-state {
  margin: 12px 0;
}

.line {
  display: flex;
  width: 100%;
}

.first-line {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.profile-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  align-self: stretch;
  flex: 0 0 220px;
  gap: 10px;
}

.profile-image-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.profile-image {
  width: 100%;
  height: 100%;
  max-width: 220px;
  max-height: 260px;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.arrival-meta-inline {
  width: 100%;
  max-width: 220px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
  border: 1px solid #c9d8ff;
  border-radius: 14px;
  padding: 10px 10px 10px 12px;
  box-shadow: 0 8px 22px rgba(35, 86, 200, 0.14);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  position: relative;
}

.arrival-meta-content {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2f4b8f;
}

.arrival-meta-content svg {
  font-size: 18px;
}

.arrival-meta-content>div {
  min-width: 0;
  position: relative;
}

.arrival-meta-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #4766a8;
}

.arrival-meta-date {
  display: block;
  font-size: 15px;
  color: #213a6c;
}

.arrival-meta-edit-btn {
  width: 32px;
  height: 32px;
  position: absolute;
  right: -10px;
  top: 10px;
  border: none;
  color: #2f6fed;
  cursor: pointer;
}

.arrival-meta-edit-btn:hover {
  transform: translateY(-1px);
}

.arrival-meta-edit-btn svg {
  font-size: 13px;
}

.arrival-date-popover {
  position: absolute;
  bottom: calc(100% + 14px);
  left: 62%;
  transform: translateX(-36%);
  width: 360px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border: 1px solid #d7e3ff;
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);
  padding: 14px;
  z-index: 99999;
}

.arrival-date-popover-arrow {
  position: absolute;
  bottom: -9px;
  left: 42%;
  width: 18px;
  height: 18px;
  background: #ffffff;
  border-right: 1px solid #d7e3ff;
  border-bottom: 1px solid #d7e3ff;
  transform: translateX(-50%) rotate(45deg);
}

.arrival-date-popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #213a6c;
}

.arrival-date-popover-header strong {
  font-size: 15px;
}

.arrival-date-popover-close {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f2f5fb;
  color: #475569;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.arrival-date-popover-body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.arrival-date-popover-body label {
  font-size: 12px;
  font-weight: 700;
  color: #4766a8;
  text-transform: uppercase;
}

.arrival-date-popover-body input {
  width: 100%;
  border: 1px solid #c9d8ff;
  border-radius: 10px;
  padding: 10px 12px;
  color: #1f2a3a;
  background: #f8fbff;
}

.arrival-date-popover-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
}

.arrival-date-cancel-btn,
.arrival-date-save-btn {
  border: none;
  border-radius: 10px;
  padding: 9px 14px;
  font-weight: 700;
  cursor: pointer;
}

.arrival-date-cancel-btn {
  background: #f2f5fb;
  color: #475569;
}

.arrival-date-save-btn {
  background: #2f6fed;
  color: #ffffff;
}

.basic-info,
.additional-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  flex: 1 1 280px;
  min-width: 0;
  box-sizing: border-box;
}

.basic-info p,
.additional-info p {
  display: block;
  background-color: var(--fundo);
  color: var(--texto);
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 12px;
  min-height: 44px;
  line-height: 1.4;
  overflow-wrap: break-word;
  word-break: normal;
  white-space: normal;
}

:is(.basic-info p,.additional-info p)  > strong {
    display: block;
    font-size: 14px;
    color: #292d32b4;
    margin-bottom: 2px;
  }

@media (max-width: 860px) {
  .first-line {
    flex-direction: column;
    align-items: stretch;
  }

  .profile-image-container,
  .basic-info,
  .additional-info {
    flex: 1 1 auto;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .profile-image {
    max-width: 180px;
    max-height: 220px;
  }

  .arrival-meta-inline {
    max-width: 180px;
  }
}

@media (max-width: 480px) {
  .profile-image-container,
  .basic-info,
  .additional-info {
    max-width: 100%;
  }

  .basic-info,
  .additional-info {
    padding: 12px;
  }
}

.second-line {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin: 0;
}

.status-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--fundo);
  border-radius: 8px;
  text-align: center;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
}

.status-box  > strong,.status-box p{
    font-size: 13px;
  }

.status-box-full-width {
  width: 100%;
  max-width: 220px;
}

.visit-flag {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: var(--ui-surface);
  cursor: pointer;
  transition: opacity 0.15s ease, box-shadow 0.15s ease;
}

.visit-flag--liberado {
  color: var(--verde);
  border: 1px solid var(--verde);
  box-shadow: 0 0 0 3px rgba(0, 121, 50, 0.12), 0 2px 8px rgba(0, 121, 50, 0.18);
}

.visit-flag--bloqueado {
  color: var(--Vermelho);
  border: 1px solid var(--Vermelho);
  box-shadow: 0 0 0 3px rgba(180, 30, 30, 0.12), 0 2px 8px rgba(180, 30, 30, 0.18);
}

.visit-flag:hover:not(:disabled) {
  opacity: 0.7;
}

.visit-flag:disabled {
  cursor: default;
  opacity: 0.6;
}

.third-line {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 40px;
}

.third-line  > h3 {
    color: var(--texto-destaque);
  }

.images-grid {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.image-thumbnail {
  width: 150px;
  height: 150px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}

.image-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

/* Galeria do detalhe do interno: miniatura + legenda (título, descrição e data) */
.images-grid--captioned {
  align-items: flex-start;
}

.image-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 150px;
}

.image-caption {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 4px;
  font-size: 0.78rem;
  line-height: 1.3;
  color: var(--texto);
}

.image-caption-title {
  color: var(--texto-destaque);
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-caption-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.image-caption-title.is-empty,
.image-caption-description.is-empty {
  color: var(--ui-muted);
  font-style: italic;
  font-weight: normal;
}

.image-main-btn {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  border: 1px solid #cfe0ff;
  background: rgba(246, 249, 255, 0.95);
  color: #2b5fd9;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.image-main-btn:hover {
  background: #e9f0ff;
}

.image-main-btn:focus-visible {
  outline: 2px solid #2b5fd9;
  outline-offset: 2px;
}

.image-actions-container {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: space-between;
  justify-content: space-between;
  gap: 8px;
  z-index: 2;
}

.image-actions-container .image-main-btn {
  position: static;
  flex: 1 1;
  margin: 0;
}

.image-main-icon-btn {
  flex: 0 0 34px !important;
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #d7c9ff;
  background: rgba(248, 245, 255, 0.95);
  color: #7b61c9;
}

.image-main-icon-btn:hover {
  background: #f1ebff;
}

.image-main-icon-btn.is-main {
  border-color: #ffc7cf;
  background: rgba(255, 240, 243, 0.98);
  color: #e63946;
}

.image-main-icon-btn.is-main:hover {
  background: #ffe4e8;
}

.image-main-icon-btn svg {
  font-size: 15px;
}

.image-delete-btn {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffd1d1;
  background: rgba(255, 245, 245, 0.95);
  color: #d62828;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.image-delete-btn:hover {
  background: #ffe7e7;
}

.image-delete-btn:focus-visible {
  outline: 2px solid #d62828;
  outline-offset: 2px;
}

.add-image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 15px;
  border: 1px dashed var(--azul);
  background-color: var(--fundo);
  border-radius: 20px;
  width: 140px;
  min-height: 140px;
  cursor: pointer;
}


.visitor-thumbnail {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.large-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  overflow-y: auto;
}

.large-image {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.large-image-details {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  border-radius: 5px;
  max-width: 80%;
}


.internal-details .div-dados .dados-gerais {
  display: flex;
}

.internal-details .div-dados .dados-gerais>div {
  width: 50%;
}

@media (max-width: 768px) {

  /* Linha 1: Imagem e Dados Principais */
  .first-line {
    gap: 0;
  }

  .profile-image-container {
    padding: 0;
  }

  .profile-image {
    width: 250px;
    height: 250px;
    margin: 20px auto;
  }

  .arrival-meta-inline {
    max-width: 250px;
  }

  /* Linha 2: Caixas de Status */
  .second-line {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 20px 0;
  }

  /* Linha 3: Imagens anexadas */
  .images-grid {
    justify-content: center;
  }

  .image-thumbnail,
  .add-image-btn {
    width: 100px;
    height: 100px;
  }

  .image-card {
    width: 100px;
  }

  .content-btn-edit {
    text-align: center;
  }
}

.btn-delete-icon {
  margin-left: 10px;
  font-size: 16px;
  ;
}

.content-btn-edit {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.content-btn-edit  > button {
    background: transparent;
    border: 1px solid var(--texto-destaque);
    color: var(--texto-destaque);
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
    padding: 6px 12px;
  }

.dados-gerais table td button,
.table-home table td a {
  background: none;
  color: var(--azul-escuro);
  font-size: 16px;
}

.title-accordion {
  cursor: pointer;
}

.icon-accordion {
  float: right;
  font-size: 20px;
}

.unit-summary-inline {
  float: right;
  margin-right: 12px;
  font-size: 13px;
  font-weight: 400;
  color: #4b5668;
}

/* Resumo da unidade no título do acordeon "Dados Gerais": ao ficar
   flutuante (float: right) e quebrar em mais de uma linha, sua altura
   não é contabilizada pelo h4, e o conteúdo do acordeon logo abaixo
   (caixa de Status) acaba sobrepondo o texto. Vira bloco próprio
   abaixo do título nas telas estreitas para não sobrepor. Essa regra
   precisa vir depois da declaração base de .unit-summary-inline acima
   (mesma especificidade) para não ser sobrescrita por ela na cascata. */
@media (max-width: 768px) {
  .unit-summary-inline {
    float: none;
    display: block;
    width: 100%;
    margin: 6px 0 0;
    text-align: left;
  }
}

.icoFile {
  cursor: pointer;
  color: var(--azul);
  font-size: 20px;
}

.doc-description {
  font-size: 12px;
  line-height: 1.4;
  color: #4b5668;
  white-space: normal;
  word-break: break-word;
}

.temporary-leaving-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
}

.temporary-leaving-status.returned {
  background: #e9f8ef;
  border-color: #b8ebcd;
  color: #1e7d47;
}

.temporary-leaving-status.active {
  background: #f3ebff;
  border-color: #d9c3ff;
  color: #6a42b9;
}

.temporary-leaving-status.inactive {
  background: #f2f4f8;
  border-color: #d7dce8;
  color: #4f5c74;
}

/* Cntainer do botao de addcionar algo com a logica do visbledAccess */
.container-visibledAccess {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.internal-details-page .content+.content {
  margin-top: 16px;
}

.content--trabalho.open {
  max-height: 800px;
  overflow-y: auto;
}

.content--trabalho .title-accordion {
  position: sticky;
  top: 0;
  background-color: var(--ui-surface);
  z-index: 10;
  margin: -16px -16px 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ui-border, #e5e7eb);
}

.discipline-timeline.visit-history-timeline {
  max-height: 600px;
}

.visit-history-timeline .timeline-dot-discipline {
  background: var(--verde);
}


/* Css do formulario de edicao de telefone em linha */

.inline-form {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.inline-form .form-edit {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.form-edit .form-input {
  width: 20rem;
}

.btn-edit-inline {
  transform: translateY(25%);
  border: 1px solid var(--azul) !important;
  padding: 10px !important;
  width: 80px;
}


/* TD de adcionar processo */
.btn-proccess {
  position: relative;
  cursor: pointer;
  color: var(--azul-escuro) !important;
  font-size: 16px;
}

.btn-proccess:hover span {
  display: block;
}

.btn-proccess>span {
  position: absolute;
  display: none;
  bottom: 0;
  left: -130px;
  font-size: 10px !important;
  text-transform: uppercase;
  font-weight: 500;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 0px 3px 0px var(--azul);
  background-color: var(--branco);
  z-index: 3;
}

.td-table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}


/* Csstd aka */
.td-vulgo {
  display: flex;
  flex-direction: column;
}


/* css botoes AKA */
.edit-internal-container {
  padding: 20px;
}

.aka-input {
  width: 100%;
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin-bottom: 10px;

  /* >input {
    width: 90% !important;
  } */
}

.aka-input  > button {
    width: 10% !important;
    background-color: transparent;
    color: var(--Vermelho);
    font-size: 22px;
    border: none;
  }

.add-aka-btn {
  background-color: var(--verde);
  letter-spacing: .5px;
  color: #fff;
  border: none;
}


/* Tooltipe de acoes da tabela */
.actions-container {
  position: relative;
  display: inline-block;
  border-radius: 8px;
}

.btn-actions {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  background-color: var(--azul-escuro);
}

.actions-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 20px;
  right: 0;
  background: #fff;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  min-width: 120px;
  border-radius: 4px;
}

.actions-menu .action-item {
  padding: 10px;
  text-align: left;
  display: block;
  text-transform: uppercase;
  font-weight: 600 !important;
  font-size: 12px;
  color: var(--azul-escuro);
  cursor: pointer;
  border-bottom: 1px solid var(--borda);
  border-radius: 0;
  z-index: 9999;
}

.actions-menu .action-item:hover {
  background-color: #f1f1f1;
}


/* liberation.css */
.liberation-submit {
  background-color: var(--verde);
  width: 100%;
  font-size: 16px;
}


/* Css detalhes de cadastro de servico social */
.social-container .content-topo {
    display: flex;
    gap: 20px;
    padding-bottom: 40px;
  }
:is(.social-container .content-topo) .content-img > img {
      border-radius: 20px;
      width: 200px;
      height: 250px;
      object-fit: cover;
    }
:is(.social-container .content-topo) .content-itens {
      display: flex;
      gap: 20px;
      width: 100%;
    }
:is(:is(.social-container .content-topo) .content-itens)  > div {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
:is(:is(:is(.social-container .content-topo) .content-itens) > div)  > p {
          display: flex;
          flex-direction: column;
          font-weight: 500;
          background-color: #fff;
          padding: 6px;
          border-radius: 12px;
          min-height: 50px;
        }
:is(:is(:is(:is(.social-container .content-topo) .content-itens) > div) > p)  > strong {
            color: #292d32b4;
          }

.social-form-busca-interno {
  position: relative;
  display: flex;
  justify-content: flex-end;

}

.social-form-busca-interno  > div {
    width: 40%;

  }

.social-form-busca-interno  > select {
    width: 100px;
  }


.social-submit-button {
  margin-top: 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: var(--azul);
  color: #fff;
  cursor: pointer;
}

.social-tabs {
  display: flex;
}

.social-tab-button {
  padding: 10px 30px;
  border: none;
  border-radius: 4px 4px 0 0;
  background-color: transparent;
  color: #292d32b4;
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid #292d32b4;
}

.social-tab-button.active {
  border-bottom: 2px solid var(--azul);
  color: var(--texto-destaque);
}

.social-tab-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 0 0 8px 8px;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
}

.social-form-group {
  flex: 1 1;
  margin-bottom: 20px;
}


.social-form-group-duplo {
  display: flex;
  gap: 20px;
}


.social-form-group-duplo  > div > select,.social-form-group-duplo  > div > input {
    margin: 0;
    padding: 15px;
    border: none;
    border-radius: 20px;
  }

.arquivo-incluso {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--azul);
}

.arquivo-incluso  > a {
    color: var(--azul);
  }

.social-form-group-duplo label {
  flex: 1 1;
}

.social-form-group-duplo select,
.social-form-group-duplo input {
  flex: 1 1;
  margin-left: 10px;
  background-color: var(--fundo);
  color: var(--ui-text);
}

.social-form-group label {
  display: block;
  margin-bottom: 5px;
}

.social-required-indicator {
  color: #d32f2f;
  font-weight: 700;
}

.required-indicator {
  color: #d32f2f;
  font-weight: 700;
  margin-left: 4px;
}

.social-form-group input,
.social-form-group select,
.social-form-group textarea {
  width: 100%;
  padding: 16px;
  border-radius: 20px;
  border: 1px solid var(--borda);
  background-color: var(--fundo);
  color: var(--ui-text);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Renderizacao de serviso social em internaldetails */
.social-service-details {
  margin-top: 20px;
}
.social-service-details  > h4 {
    margin-top: 40px;
  }
.social-service-details  > div {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 10px;
  }
:is(.social-service-details > div)  > div {
      border-radius: 10px;
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(33.333% - 20px);
      padding: 8px;
      background-color: var(--fundo);
      color: var(--texto);
    }

.admission-health-details {
  margin-top: 20px;
}

.admission-health-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}

.admission-health-card {
  background: #f5f8ff;
  border: 1px solid #e3e9f6;
  border-radius: 12px;
  padding: 12px;
}

.admission-health-card h5 {
  margin: 0 0 6px;
  font-size: 12px;
  color: #3b4a66;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.admission-health-card p {
  margin: 0;
  color: #1f2a3a;
  font-size: 14px;
  word-break: break-word;
}

.admission-health-card--wide {
  grid-column: 1 / -1;
}

.inclusion-timeline {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 10px 4px;
}

.inclusion-timeline-item {
  border: 1px solid #e3e9f6;
  background: #f8faff;
  border-radius: 12px;
  padding: 12px 14px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.inclusion-timeline-item:hover {
  border-color: #c6d7ff;
  background: #eef4ff;
}

.inclusion-timeline-item:focus-visible {
  outline: 2px solid #2f6fed;
  outline-offset: 2px;
}

.inclusion-timeline-date {
  font-weight: 700;
  color: #1f2a3a;
}

.inclusion-timeline-meta {
  display: flex;
  gap: 14px;
  color: #3b4a66;
  font-size: 13px;
  flex-wrap: wrap;
  align-items: center;
}

.inclusion-quick-view-btn {
  padding: 4px 10px;
  font-size: 12px;
}


.arquivo {
  height: 100px;
  display: flex;
  flex-direction: column;
}


.arquivo  > a {
    width: 45px;
    height: 45px;
    padding: 9px;
    border: 1.2px solid var(--texto-destaque);
    border-radius: 6px;
    font-size: 14px;
    color: var(--texto-destaque);
    font-weight: 600;
  }


:is(.arquivo > a)  > img {
      margin-bottom: 7px;
    }


.social-service-details h5 {
  font-size: 14px;
  font-weight: bold;
  color: #292d32b4;
  margin-bottom: 5px;
}

.aka-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 4px 20px 0;
}

.aka-tags span {
    background: var(--texto-destaque);
    color: white;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 10px;
  }

:is(.aka-tags span) button {
      font-size: 14px !important;
      border: none;
      padding: 0;
      color: white;
      margin-left: 5px;
      transform: translateY(1px);
    }


/* Estilos Gerais */
.evolucao-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}


.social-form-group label {
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
  color: var(--texto-destaque);
}

.social-form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--borda);
  border-radius: 8px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  resize: none;
}

.social-submit-button {
  background-color: var(--verde);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}


/* Linha do Tempo */
.timeline {
  flex: 2 1;
  padding: 20px;
  border-radius: 8px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  position: relative;
}

.timeline h4 {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: bold;
  color: var(--texto-destaque);
}

.timeline-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.timeline-list::before {
  content: '';
  position: absolute;
  top: 0;
  left: 20px;
  bottom: 0;
  width: 2px;
  background-color: var(--borda);
}

.timeline-item {
  margin-bottom: 20px;
  position: relative;
  padding-left: 40px;
}

.timeline-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 13px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: var(--verde);
  box-shadow: 0 0 0 5px #fff;
}

.timeline-date {
  font-size: 14px;
  font-weight: bold;
  color: #777;
  margin-bottom: 5px;
}

.timeline-content {
  border-radius: 8px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}

.timeline-content  > p {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 20px);
    color: var(--texto);
    display: flex;
    flex-direction: column;
    background: var(--fundo);
    padding: 10px;
    font-weight: 600;
  }

:is(.timeline-content > p)  > strong {
      color: #292d32b4;
    }


/* Enderecos no serviso social */
.address-tab-content {
  margin-top: 20px;
}

.add-address-button {
  background-color: var(--verde) !important;
  color: #fff !important;
  padding: 10px !important;
  margin-bottom: 20px;
  border: none;
}

.edit-address-button {
  color: var(--azul);
  font-size: 20px;

}

/* bursca de pais e cidade */
.form-field {
  position: relative;
}

.cpf-searching {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #4c6fff;
}

.form-field .suggestions-list {
  border-radius: 8px;
  border: 1px solid #ccc;
  max-height: 200px;
  min-width: 200px;
  overflow-y: auto;
  background-color: white;
  position: absolute;
  bottom: 10px;
  left: 30px;
  z-index: 1000;
}

.form-field .suggestions-list-cities {
  border-radius: 8px;
  border: 1px solid #ccc;
  max-height: 200px;
  min-width: 200px;
  overflow-y: auto;
  background-color: white;
  position: absolute;
  top: 75px;
  left: 30px;
  z-index: 1000;
}

.form-field .suggestions-list li,
.form-field .suggestions-list-cities li {
  padding: 10px;
  cursor: pointer;
}

.form-field .suggestions-list li:hover,
.form-field .suggestions-list-cities li:hover {
  background-color: #f0f0f0;
}

.form-field .suggestions-list-cities.process-field-suggestions {
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  max-width: 100%;
}

.address-modal-form .modal-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}

.address-modal-form .field-half {
  grid-column: span 1;
}

.address-modal-form .field-full {
  grid-column: 1 / -1;
}

.address-modal-form .modal-form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.address-modal-form .modal-form-actions .btn-edit {
  min-width: 140px;
}

.temporary-return-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 6px 10px 2px;
}

.temporary-return-form .modal-form {
  margin-bottom: 0;
}

.temporary-return-form .modal-form input[readonly] {
  background: #f5f7fc;
  color: #30405f;
}

.temporary-return-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.temporary-return-actions .btn-edit,
.temporary-return-actions .save-btn {
  min-width: 160px;
}


/* Link de quando o interno tem outro cadastro */
.other-internal {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--vermelho2);
  border: 1px solid var(--Vermelho);
  animation: blink 0.3s ease-in-out 4;
}
.other-internal  > a,.other-internal  > span {
    color: var(--Vermelho);
    padding: 10px 10%;
    text-transform: uppercase;
    text-align: center;
  }

.link-internal-section {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f9fafb;
}

.link-internal-title {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #374151;
  margin-bottom: 8px;
}

.link-internal-info {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 14px;
  line-height: 1.5;
}

.link-internal-current {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #374151;
}

.link-internal-unlink-btn {
  background: none;
  border: 1px solid var(--Vermelho);
  color: var(--Vermelho);
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.link-internal-unlink-btn:hover {
    background-color: var(--vermelho2);
  }

.link-internal-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.link-internal-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #374151;
  flex-wrap: wrap;
}

.other-internal--green {
  background-color: #d4edda;
  border-color: var(--verde);
  animation: blink 0.3s ease-in-out 4;
}

.other-internal--green  > a,.other-internal--green  > span {
    color: var(--verde);
  }

.other-internal-info {
  width: 100%;
  padding: 6px 5%;
  background-color: #f0f4f0;
  color: #4a6b4a;
  font-size: 12px;
  text-align: center;
}

.other-internal-warning {
  width: 100%;
  padding: 8px 5%;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
}

.other-internal-warning  > a {
    color: #856404;
    text-decoration: underline;
    font-weight: 700;
  }

.internal-type-flag {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.internal-type-flag--principal {
  background-color: #d4edda;
  color: var(--verde);
  border: 1px solid var(--verde);
}

.internal-type-flag--secundario {
  background-color: var(--vermelho2);
  color: var(--Vermelho);
  border: 1px solid var(--Vermelho);
}

.save-btn {
  background-color: var(--verde);
  color: white;
  border: none;
}

/* Definição da animação */
@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

/* Ajustes de responsividade */

@media (max-width: 1200px) {}

@media (max-width: 992px) {
  .social-form-busca-interno {
    flex-direction: row !important;
    align-items: center;
    justify-content: center;
  }

    .social-form-busca-interno  > div {
      width: 60% !important;
    }

    .social-form-busca-interno  > select {
      width: 40%;
    }

  .social-form-group-duplo {
    flex-direction: column;
    gap: 10px;
  }

  .address-modal-form .modal-form-grid {
    grid-template-columns: 1fr;
  }

  .address-modal-form .field-half,
  .address-modal-form .field-full {
    grid-column: 1 / -1;
  }

  .address-modal-form .modal-form-actions .btn-edit {
    width: 100%;
  }

  .social-tabs {
    flex-wrap: wrap;
    justify-content: center;
  }

  .social-tab-button {
    flex: 1 1 100%;
    text-align: center;
  }

  .btn-h2 {
    flex-direction: column;
    align-items: flex-start;
  }

    .btn-h2  > h2 {
      margin-bottom: 10px;
    }

  .social-service-details div {
    flex: 1 1 100%;
  }

  .social-submit-button {
    width: 100%;
    padding: 15px;
    font-size: 16px;
  }

  .timeline {
    padding: 15px;
  }

  .timeline-item {
    padding-left: 20px;
  }

  .timeline-list::before {
    left: 10px;
  }

  .timeline-item::before {
    left: 3px;
  }
}

@media (max-width: 768px) {
  .social-form-busca-interno {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

    .social-form-busca-interno  > div {
      width: 100%;
    }

    .social-form-busca-interno  > select {
      width: 100%;
    }

  .social-tabs {
    flex-direction: column;
  }

  .social-tab-button {
    width: 100%;
    padding: 15px;
  }

  .social-tab-content {
    padding: 15px;
  }

  .social-form-group-duplo {
    flex-direction: column;
    gap: 10px;
  }

  .timeline {
    padding: 10px;
  }

  .timeline-item {
    padding-left: 15px;
  }

  .timeline-list::before {
    left: 8px;
  }

  .timeline-item::before {
    left: 0;
  }
}

@media (max-width: 576px) {
  .btn-h2 {
    align-items: center;
    text-align: center;
  }

  .btn-h2 h2 {
    font-size: 18px;
  }

  .social-form-group textarea {
    padding: 10px;
  }

  .social-submit-button {
    padding: 10px;
    font-size: 14px;
  }

  .social-service-details div {
    padding: 10px;
  }

  .timeline {
    padding: 10px;
  }

  .timeline-content {
    font-size: 12px;
  }
}



/* Busca do Processo */
.process-search-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.process-search-container input {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--borda);
  border-radius: 6px;
  font-size: 14px;
}

.process-search-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 1000;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

.process-search-results-capitulation {
  width: 100%;
  top: calc(100% + 2px);
  left: 0;
}

.process-search-results div {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.process-search-results div:hover {
  background-color: var(--fundo);
  color: var(--texto-destaque);
}

.process-capitulation-input {
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
}

.process-capitulation-input input {
  flex: 1 1;
}

.process-search-loading {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #4c6fff;
}

.process-capitulation-add {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--borda);
  background: #f7f9ff;
  color: var(--texto-destaque);
  font-size: 18px;
  cursor: pointer;
}

.process-capitulation-add:hover {
  background: #eef3ff;
}

.processes-table {
  table-layout: auto;
  min-width: 920px;
}

.processes-table .process-col-court,
.processes-table .process-col-capitulation {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  vertical-align: top;
}

.processes-table th.process-col-court,
.processes-table td.process-col-court {
  min-width: 220px;
  max-width: 260px;
}

.processes-table th.process-col-capitulation,
.processes-table td.process-col-capitulation {
  min-width: 300px;
  max-width: 380px;
}

.process-capitulation-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.process-capitulation-item {
  line-height: 1.35;
}

@media (max-width: 1024px) {
  .processes-table {
    min-width: 860px;
  }

  .processes-table th.process-col-court,
  .processes-table td.process-col-court {
    min-width: 180px;
    max-width: 220px;
  }

  .processes-table th.process-col-capitulation,
  .processes-table td.process-col-capitulation {
    min-width: 260px;
    max-width: 320px;
  }
}

.social-service-layout {
  background: #ffffff;
  border: 1px solid #e4e9f6;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  margin-top: 12px;
}

.social-service-layout .social-tabs {
  margin-top: 0;
}

.social-service-layout .social-tab-content {
  margin-top: 12px;
}


/* ===============================
   Webcam / Upload de imagem (RegisterInternal)
   =============================== */

/* Wrapper quando a webcam está ativa */
.image-upload-webcam {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Preview da webcam */
.image-upload-webcam video {
  width: 100%;
  border-radius: 10px;
}

/* Ações da webcam (botões) */
.image-upload-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

/* Botão padrão secundário (usar arquivos) */
.btn-secondary {
  background-color: var(--fundo);
  border: 1px solid var(--texto-destaque);
  color: var(--texto-destaque);
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}

/* Botão de ação principal (tirar foto) */
.btn-primary {
  background-color: var(--texto-destaque);
  border: none;
  color: var(--branco);
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}

/* Mensagem de erro da câmera */
.camera-error {
  font-size: 13px;
  color: var(--Vermelho);
  text-align: center;
}

/* 
   AddImage - botão "Clique para abrir câmera ou selecionar arquivo"
    */

.input-visual {
  width: 100%;
  min-height: 52px;
  padding: 14px 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--fundo);
  border: 1px dashed var(--borda);
  border-radius: 12px;

  color: var(--texto-destaque);
  font-weight: 600;
  text-align: center;

  cursor: pointer;
  transition: 0.2s ease;
}

/* Efeito hover */
.input-visual:hover {
  border-color: var(--texto-destaque);
  background-color: rgba(0, 0, 0, 0.02);
}

/* Foco via teclado (tab) */
.input-visual:focus {
  outline: none;
  border-color: var(--texto-destaque);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);
}

/* Texto interno */
.input-visual span {
  font-size: 14px;
  line-height: 1.2;
}

/* Responsivo */
@media (max-width: 768px) {
  .input-visual {
    min-height: 48px;
    padding: 12px 14px;
  }
}

/*
   AddImage - botão "Clique para abrir câmera ou selecionar arquivo"
   */

.input-error-text {
  color: red;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}

.input-visual {
  width: 100%;
  min-height: 52px;
  padding: 14px 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--fundo);
  border: 1px dashed var(--borda);
  border-radius: 12px;

  color: var(--texto-destaque);
  font-weight: 600;
  text-align: center;

  cursor: pointer;
  transition: 0.2s ease;
}

/* Efeito hover */
.input-visual:hover {
  border-color: var(--texto-destaque);
  background-color: rgba(0, 0, 0, 0.02);
}

/* Foco via teclado (tab) */
.input-visual:focus {
  outline: none;
  border-color: var(--texto-destaque);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);
}

/* Texto interno */
.input-visual span {
  font-size: 14px;
  line-height: 1.2;
}

/* Responsivo */
@media (max-width: 768px) {
  .input-visual {
    min-height: 48px;
    padding: 12px 14px;
  }
}

/* Novos estilos para campos em linha nos modais */
.form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.form-field-small {
  flex: 1 1;
  min-width: 80px;
}

.form-field-half {
  flex: 1 1;
  min-width: 200px;
}

/* Botões de ação nas tabelas de Processo e Execução Penal */
.btn-action-edit,
.btn-action-view {
  background: transparent;
  border: none;
  cursor: pointer;
  margin-right: 12px;
  /* Adiciona o espaço entre os ícones */
  font-size: 16px;
  transition: opacity 0.2s;
}

.btn-action-edit:hover,
.btn-action-view:hover {
  opacity: 0.7;
}

.btn-action-edit {
  color: var(--azul-escuro);
}

.btn-action-view {
  color: var(--azul);
}

/* Prévia do Interno no Agendamento */
.appointment-internal-preview {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f8f9fd;
  padding: 12px;
  border-radius: 12px;
  margin-top: 8px;
  border: 1px solid #e4e8f2;
}

.appointment-internal-image-preview {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--azul);
  flex-shrink: 0;
  background: #fff;
}

.appointment-internal-info-preview {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.appointment-internal-info-preview strong {
  font-size: 14px;
  color: var(--texto);
}

.appointment-internal-info-preview span {
  font-size: 12px;
  color: #666;
}

/* Grid de Agendamentos do Advogado */
.appointments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.appointment-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e8edf2;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.appointment-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06);
}

.appointment-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f4f8;
  flex-wrap: nowrap;
  /* Garante que o badge não quebre para a linha de baixo */
  min-height: 40px;
  /* Garante espaço mínimo para o cabeçalho */
}

.appointment-card-header h3 {
  margin: 0;
  font-size: 16px;
  color: var(--azul-escuro);
  white-space: normal;
  flex: 1 1;
  margin-right: 10px;
  line-height: 1.4;
}

.appointment-status-badge {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.status-active {
  background: #e0f2fe;
  color: #0369a1;
}

.status-done {
  background: #dcfce7;
  color: #15803d;
}

.status-canceled {
  background: #fee2e2;
  color: #b91c1c;
}

.status-expired {
  background: #dc2626;
  color: #ffffff;
}

.status-pending {
  background: #fef9c3;
  color: #854d0e;
}

.status-warning {
  background: #fed7aa;
  color: #9a3412;
}

/* Header do card de agendamento de advogado */
.adv-card-header {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f4f8;
  margin-bottom: 4px;
}

.adv-card-badge-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.adv-card-header-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}

.adv-card-internal-name {
  margin: 0 0 2px;
  font-size: 13px;
  font-weight: 700;
  color: var(--azul-escuro);
  line-height: 1.3;
}

.adv-card-lawyer-block {
  display: flex;
  flex-direction: column;
  margin-top: 6px;
}

.adv-card-lawyer-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  line-height: 1.2;
}

.adv-card-lawyer-name {
  font-size: 11px;
  color: var(--ui-muted);
  line-height: 1.3;
}

.adv-card-unit-name {
  margin: 2px 0 0;
  font-size: 11px;
  color: var(--ui-muted);
  line-height: 1.3;
  font-style: italic;
}

/* Observação em bloco */
.adv-observation {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: #f8fafc;
  border-left: 3px solid #94a3b8;
  border-radius: 4px;
}

.adv-observation strong {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.adv-observation p {
  margin: 0;
  font-size: 13px;
  color: #374151;
}

/* Motivo cancelamento em bloco */
.adv-cancel-reason {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: #fff1f2;
  border-left: 3px solid #b91c1c;
  border-radius: 4px;
}

.adv-cancel-reason strong {
  font-size: 11px;
  color: #b91c1c;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.adv-cancel-reason p {
  margin: 0;
  font-size: 13px;
  color: #374151;
}

/* Tags de tipo de atendimento */
.tag-presencial {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  background: #dbeafe;
  color: #1d4ed8;
}

.tag-virtual {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  background: #d1fae5;
  color: #065f46;
}

.appointment-card-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
}

.appointment-info-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  word-break: break-word;
  /* Garante que o texto quebre */
  white-space: normal;
  /* Permite que o texto quebre */
}

.appointment-info-item strong {
  flex-shrink: 0;
  /* Impede que o label encolha */
  margin-right: 8px;
  /* Espaço entre label e valor */
}

.appointment-card-footer {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: auto;
}

.btn-action-complete {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #a7f3d0;
}

.btn-action-complete:hover {
  background: #bbf7d0;
}

.btn-authorized-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #15803d;
  padding: 4px 0;
}

.appointment-info-item strong {
  color: #64748b;
}

.appointment-info-item span {
  color: var(--texto);
  font-weight: 500;
}

/* process is_active toggle */
.checkbox-label-process {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
}

.process-active-toggle {
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  border: 1px solid;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.process-active-toggle--active {
  background-color: #f0fdf4;
  border-color: #86efac;
}

.process-active-toggle--inactive {
  background-color: #fff7ed;
  border-color: #fdba74;
}

.process-active-toggle__label {
  margin-bottom: 0;
}

.process-active-toggle__status {
  font-weight: 600;
  font-size: 0.95rem;
}

.process-active-toggle--active .process-active-toggle__status {
  color: #15803d;
}

.process-active-toggle--inactive .process-active-toggle__status {
  color: #c2410c;
}

.process-active-toggle__hint {
  font-size: 0.78rem;
  color: #64748b;
  margin-left: 24px;
}

/* process status (readOnly) */
.process-status-label {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.85rem;
}

.process-status-active {
  background-color: #dcfce7;
  color: #15803d;
}

.process-status-inactive {
  background-color: #ffedd5;
  color: #c2410c;
}

/* ==========================================================================
   Fluxo unificado de entrada (unifiedEntry.js)
   Usa os tokens --ui-* já definidos em src/index.css como base do visual novo.
   ========================================================================== */
.unified-entry {
  padding: 8px 4px 24px;
}

.unified-entry__header {
  margin-bottom: 20px;
}

.unified-entry__header h2 {
  margin: 0 0 4px;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--ui-text);
}

.unified-entry__header p {
  margin: 0;
  color: var(--ui-muted);
  font-size: 0.9rem;
}

/* --- Seletor de tipo de entrada (cards) --- */
.unified-entry__types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.unified-entry__type-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 10px;
  min-height: 140px;
  padding: 18px 14px 20px;
  border: 1.5px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  background: var(--ui-surface);
  cursor: pointer;
  text-align: center;
  font-family: inherit;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease, background 0.15s ease;
}

.unified-entry__type-card:hover {
  border-color: var(--ui-primary);
  box-shadow: var(--ui-shadow-sm);
  transform: translateY(-2px);
}

.unified-entry__type-card.is-active {
  border-color: var(--ui-primary);
  background: linear-gradient(180deg, rgba(3, 78, 162, 0.06), rgba(3, 78, 162, 0.02));
  box-shadow: var(--ui-shadow-md);
}

.unified-entry__type-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  max-width: 44px;
  max-height: 44px;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: var(--ui-input-bg);
  color: var(--ui-primary);
  overflow: hidden;
}

.unified-entry__type-icon svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.unified-entry__type-card.is-active .unified-entry__type-icon {
  background: var(--ui-primary);
  color: var(--ui-primary-contrast);
}

.unified-entry__type-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--ui-text);
  line-height: 1.25;
  overflow-wrap: break-word;
}

.unified-entry__type-description {
  font-size: 0.72rem;
  font-weight: 400;
  color: var(--ui-muted);
  line-height: 1.3;
  overflow-wrap: break-word;
}

/* --- Painel de conteúdo (aparece após escolher o tipo) --- */
.unified-entry__panel {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-sm);
  padding: 24px;
  animation: unified-entry-fade-in 0.2s ease;
}

@keyframes unified-entry-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

.unified-entry__hint {
  font-size: 0.85rem;
  color: var(--ui-muted);
  margin: 0 0 12px;
}

.unified-entry__hint--error {
  color: var(--Vermelho, #ef4123);
}

.unified-entry__notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 18px;
  border-radius: var(--ui-radius-sm);
  background: var(--amarelo3, #fff4de);
  color: #8a5a00;
  font-size: 0.85rem;
}

.unified-entry__notice svg {
  flex-shrink: 0;
}

/* --- Busca por CPF (retorno simples) --- */
.unified-entry__search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.unified-entry__search-icon {
  position: absolute;
  left: 14px;
  color: var(--ui-muted);
  pointer-events: none;
}

/* \`input[type]\` (em vez de só \`input\`) pra ganhar em especificidade do seletor global
   \`input[type="text"] { padding: 12px 14px; ... }\` de src/index.css — com só \`.classe input\`
   as duas regras empatam em especificidade e quem ganha vira uma loteria da ordem de import. */
.unified-entry__search input[type] {
  width: 100%;
  padding: 12px 40px;
  border-radius: var(--ui-radius-md);
  border: 1.5px solid var(--ui-border);
  background: var(--ui-input-bg);
  font-size: 0.95rem;
}

.unified-entry__search input[type]:focus {
  outline: none;
  border-color: var(--ui-primary);
}

.unified-entry__search input[type]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.unified-entry__or {
  text-align: center;
  font-size: 0.75rem;
  color: var(--ui-muted);
  margin: -6px 0 12px;
}

.unified-entry__spinner,
.unified-entry__spinner-inline {
  width: 14px;
  height: 14px;
  border: 2px solid var(--ui-border);
  border-top-color: var(--ui-primary);
  border-radius: 50%;
  animation: unified-entry-spin 0.7s linear infinite;
}

.unified-entry__spinner {
  position: absolute;
  right: 14px;
}

.unified-entry__spinner-inline {
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
}

@keyframes unified-entry-spin {
  to { transform: rotate(360deg); }
}

/* --- Cartão do interno encontrado --- */
.unified-entry__found {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: var(--ui-radius-md);
  background: var(--ui-input-bg);
  margin-bottom: 18px;
}

.unified-entry__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--ui-primary);
  color: var(--ui-primary-contrast);
  font-weight: 700;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.unified-entry__found-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
}

.unified-entry__found-info strong {
  color: var(--ui-text);
  font-size: 0.95rem;
}

.unified-entry__found-info span {
  color: var(--ui-muted);
  font-size: 0.8rem;
}

.unified-entry__found-check {
  color: var(--verde);
  font-size: 1.1rem;
}

/* --- Grid de campos --- */
.unified-entry__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 8px;
}

.unified-entry__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}

.unified-entry__field--full {
  grid-column: 1 / -1;
}

.unified-entry__field label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ui-muted);
}

.unified-entry__required {
  color: var(--Vermelho, #ef4123);
  margin-left: 2px;
}

.unified-entry__field input[type],
.unified-entry__field select,
.unified-entry__field textarea {
  padding: 10px 12px;
  border-radius: var(--ui-radius-sm);
  border: 1.5px solid var(--ui-border);
  background: var(--ui-input-bg);
  font-size: 0.9rem;
  font-family: inherit;
  color: var(--ui-text);
  transition: border-color 0.15s ease;
}

.unified-entry__field input[type]:focus,
.unified-entry__field select:focus,
.unified-entry__field textarea:focus {
  outline: none;
  border-color: var(--ui-primary);
}

.unified-entry__field select:disabled,
.unified-entry__field input[type]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.unified-entry__field textarea {
  min-height: 70px;
  resize: vertical;
}

/* --- Autocomplete (nacionalidade/naturalidade) --- */
.unified-entry__field--autocomplete {
  position: relative;
}

.unified-entry__suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  list-style: none;
  margin: 0;
  padding: 6px;
  max-height: 190px;
  overflow-y: auto;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-sm);
  box-shadow: var(--ui-shadow-md);
}

.unified-entry__suggestions li {
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
}

.unified-entry__suggestions li:hover {
  background: var(--ui-input-bg);
  color: var(--ui-primary);
}

/* --- Toggle Sim/Não --- */
.unified-entry__toggle {
  display: inline-flex;
  border-radius: var(--ui-radius-sm);
  border: 1.5px solid var(--ui-border);
  overflow: hidden;
  width: fit-content;
}

.unified-entry__toggle button {
  padding: 9px 18px;
  border: none;
  background: var(--ui-input-bg);
  color: var(--ui-muted);
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.unified-entry__toggle button + button {
  border-left: 1.5px solid var(--ui-border);
}

.unified-entry__toggle button.is-active {
  background: var(--ui-primary);
  color: var(--ui-primary-contrast);
}

/* --- Seções (wizard) --- */
.unified-entry__section {
  margin-bottom: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--ui-border);
}

.unified-entry__section:first-of-type {
  padding-top: 0;
  border-top: none;
}

.unified-entry__section h3 {
  margin: 0 0 14px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ui-primary);
}

/* --- Stepper --- */
.unified-entry__stepper {
  display: flex;
  align-items: center;
  margin-bottom: 26px;
}

.unified-entry__step {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.unified-entry__step-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--ui-input-bg);
  border: 1.5px solid var(--ui-border);
  color: var(--ui-muted);
  font-size: 0.8rem;
  font-weight: 700;
  flex-shrink: 0;
}

.unified-entry__step.is-active .unified-entry__step-dot {
  background: var(--ui-primary);
  border-color: var(--ui-primary);
  color: var(--ui-primary-contrast);
}

.unified-entry__step.is-done .unified-entry__step-dot {
  background: var(--verde);
  border-color: var(--verde);
  color: var(--branco);
}

.unified-entry__step-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ui-muted);
  white-space: nowrap;
}

.unified-entry__step.is-active .unified-entry__step-label {
  color: var(--ui-text);
}

.unified-entry__step-line {
  flex: 1 1;
  height: 2px;
  background: var(--ui-border);
  margin: 0 8px;
  min-width: 16px;
}

.unified-entry__step-line.is-done {
  background: var(--verde);
}

/* --- Foto de perfil / upload --- */
.unified-entry__photo-row {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;
}

.unified-entry__photo {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px dashed var(--ui-border);
  background: var(--ui-input-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: border-color 0.15s ease;
}

.unified-entry__photo:hover {
  border-color: var(--ui-primary);
}

.unified-entry__photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.unified-entry__photo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: var(--ui-muted);
  font-size: 0.7rem;
  text-align: center;
  padding: 8px;
}

.unified-entry__photo-placeholder svg {
  font-size: 1.4rem;
  color: var(--ui-primary);
}

.unified-entry__photo-hint {
  color: var(--ui-muted);
  font-size: 0.85rem;
  max-width: 320px;
}

.unified-entry__webcam {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--azul-escuro);
  border-radius: 50%;
  overflow: hidden;
}

.unified-entry__webcam video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.unified-entry__photo-actions {
  position: absolute;
  bottom: 6px;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 2;
}

.unified-entry__photo-actions button {
  font-size: 0.6rem;
  padding: 4px 6px;
}

/* Upload da ficha assinada: retangular, não circular */
.unified-entry__upload-zone {
  position: relative;
  width: 100%;
  min-height: 180px;
  border-radius: var(--ui-radius-md);
  border: 2px dashed var(--ui-border);
  background: var(--ui-input-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s ease;
}

.unified-entry__upload-zone:hover {
  border-color: var(--ui-primary);
}

.unified-entry__upload-zone img {
  width: 100%;
  max-height: 260px;
  object-fit: contain;
}

.unified-entry__upload-zone .unified-entry__webcam {
  border-radius: var(--ui-radius-md);
}

.unified-entry__upload-zone .unified-entry__photo-placeholder svg {
  font-size: 1.8rem;
}

/* Sobrescreve a regra global \`form { display: flex; flex-wrap: wrap; }\` de src/index.css —
   sem isso, as seções do formulário viram itens de um flex que quebra linha, e o botão de
   ação (que não tem largura própria) acaba "sobrando" ao lado do último campo em vez de ficar
   numa linha só pra ele, embaixo de tudo. */
.unified-entry__form {
  display: block;
}

/* --- Botões --- */
.unified-entry__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.unified-entry__btn-primary,
.unified-entry__btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  border-radius: var(--ui-radius-sm);
  font-size: 0.85rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  border: 1.5px solid transparent;
  transition: filter 0.15s ease, background 0.15s ease;
}

.unified-entry__btn-primary {
  background: var(--ui-primary);
  color: var(--ui-primary-contrast);
}

.unified-entry__btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.unified-entry__btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.unified-entry__btn-secondary {
  background: var(--ui-surface);
  color: var(--ui-text);
  border-color: var(--ui-border);
}

.unified-entry__btn-secondary:hover:not(:disabled) {
  border-color: var(--ui-primary);
  color: var(--ui-primary);
}

@media (max-width: 640px) {
  .unified-entry__panel {
    padding: 16px;
  }

  .unified-entry__photo-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .unified-entry__stepper {
    flex-wrap: wrap;
    row-gap: 10px;
  }
}

.internals-summary-badges {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 8px;
}

.internals-summary-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: var(--ui-radius-md);
  border: 1px solid transparent;
  line-height: 1.4;
}

.internals-summary-badge strong {
  font-weight: 800;
}

.internals-summary-badge-count {
  color: #2b3a55;
  background: #f7f9fe;
  border-color: #e1e8f6;
}

.internals-summary-badge-vagas {
  color: #15803d;
  background: #dcfce7;
  border-color: #bbf7d0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Internos/internos.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iBAAiB;;AAmCnB;;AAjCE;IACE,YAAY;IACZ,YAAY;EACd;;AAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;AAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EAWrB;;AATE;MACE,8BAA8B;MAC9B,iBAAiB;MACjB,eAAe;IAKjB;;AAHE;QACE,4BAA4B;MAC9B;;AAMN;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,SAAS;EACT,uCAAuC;AACzC;;;;AAIA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;;AAkBlB;;AAhBE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;AAEA;IACE,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;AAKF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;EAKf;;IAHE;MACE,mBAAmB;IACrB;;EAGF;IACE,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,uCAAuC;IACvC,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;AACF;;;AAGA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,SAAO;EACP,aAAa;AACf;;;AAGA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AAQrB;;AANE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;AAGF;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;AAI9C;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,gFAAgF;AAClF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AAKtB;;AAHE;IACE,4BAA4B;EAC9B;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;EAC9B,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,uCAAuC;EACvC;IACE,MAAM;EACR;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,qCAAqC;IACrC,SAAS;IACT,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAY3B;;AAVE;IACE,uBAAuB;IACvB,uCAAuC;IACvC,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;EACnB;;AAGF;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;wEAMwE;AACxE;EACE;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mCAAmC;EACnC,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,wBAAwB;EACxB,WAAW;AACb;;;AAGA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;;EAEnB;;KAEG;AASL;;AAPE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,YAAY;EACd;;AAGF;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;;AAGA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;;AAGA,+CAA+C;AAE7C;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;EAmCtB;AAjCE;MACE,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,iBAAiB;IACnB;AAEA;MACE,aAAa;MACb,SAAS;MACT,WAAW;IAsBb;AApBE;QACE,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,8BAA8B;MAehC;AAbE;UACE,aAAa;UACb,sBAAsB;UACtB,gBAAgB;UAChB,sBAAsB;UACtB,YAAY;UACZ,mBAAmB;UACnB,gBAAgB;QAKlB;AAHE;YACE,gBAAgB;UAClB;;AAOV;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;AAW3B;;AATE;IACE,UAAU;;EAEZ;;AAEA;IACE,YAAY;EACd;;;AAKF;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,SAAS;AASX;;;AAPE;IAEE,SAAS;IACT,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AAKpB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,SAAO;AACT;;AAEA;;EAEE,SAAO;EACP,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;AAoBlB;AAlBE;IACE,gBAAgB;EAClB;AAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EASrB;AAPE;MACE,mBAAmB;MACnB,YAA8B;MAA9B,cAA8B;MAA9B,gCAA8B;MAC9B,YAAY;MACZ,8BAA8B;MAC9B,mBAAmB;IACrB;;AAIJ;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AAgBxB;;;AAdE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;EAKlB;;;AAHE;MACE,kBAAkB;IACpB;;;AAKJ;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AAkBpB;;AAhBE;IACE,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EAUjB;;AARE;MACE,0BAA0B;MAC1B,YAAY;MACZ,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,0BAA0B;IAC5B;;;AAKJ,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,sCAAsC;AACxC;;;AAGA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AAef;;AAbE;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;IACb,gBAAgB;EAKlB;;AAHE;MACE,gBAAgB;IAClB;;;AAKJ,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA,gDAAgD;AAChD;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;AAQrC;AANE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AAKjB;;AAHE;IACE,kCAAkC;EACpC;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,mCAAmC;AAKrC;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAOlB;;AALE;IACE,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;EAClB;;AAGF;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA,0BAA0B;AAC1B;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,8BAA8B;;AAE9B,4BAA4B;;AAE5B;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;EASzB;;IAPE;MACE,qBAAqB;IACvB;;IAEA;MACE,UAAU;IACZ;;EAGF;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EAKzB;;IAHE;MACE,mBAAmB;IACrB;;EAGF;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EASX;;IAPE;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;EAGF;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;;;AAIA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;oCAEoC;;AAEpC,uCAAuC;AACvC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;KAEK;;AAEL;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;;EAEnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;EACf,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;;IAEI;;AAEJ;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;;EAEnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;EACf,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;;EAEE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,wEAAwE;EACxE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;EACjB,yDAAyD;EACzD,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;+EAG+E;AAC/E;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,uGAAuG;AACzG;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mFAAmF;EACnF,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;+FAE+F;AAC/F;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;EACpC,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;4CAG4C;AAC5C;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".searchContainer {\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 0;\n  min-height: 150px;\n\n  >form>select {\n    width: 100px;\n    height: 50px;\n  }\n\n  >form>div {\n    width: 300px;\n    height: 50px;\n    margin-left: 10px;\n  }\n\n  >div {\n    position: absolute;\n    top: 65px;\n    right: 0;\n    width: auto;\n    max-width: 400px;\n    max-height: 100px;\n    overflow-y: auto;\n    padding: 0 6px;\n    border-radius: 20px;\n\n    >.search-result-item {\n      background-color: var(--fundo);\n      padding: 6px 10px;\n      cursor: pointer;\n\n      &:hover {\n        color: var(--texto-destaque);\n      }\n    }\n  }\n\n}\n\n.searchContainer>* {\n  margin: 0;\n}\n\n.titulo-children form {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.titulo-children form select {\n  width: 100px;\n  padding: 10px;\n  border: none;\n  color: var(--texto);\n  background-color: var(--branco);\n  margin: 0;\n  border: 1px solid var(--texto-destaque);\n}\n\n.titulo-children form .status-filter-select {\n  width: 190px;\n}\n\n.titulo-children form input {\n  width: 300px;\n  padding: 10px;\n  border: none;\n  background-color: var(--branco);\n  margin: 0;\n  border: 1px solid var(--texto-destaque);\n}\n\n\n\n/* Formulario de cadastrar interno */\n.content-register-internal {\n  position: relative;\n  background-color: var(--branco);\n  padding: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.register-steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 10px 20px 0;\n}\n\n.register-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f4f6fb;\n  border-radius: 12px;\n  padding: 10px 14px;\n  color: var(--texto-destaque);\n  border: 1px solid #e4e8f2;\n}\n\n.register-step span {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #d7ddea;\n  color: #5b6474;\n  font-weight: 600;\n}\n\n.register-step p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.register-step.active {\n  background: #eef4ff;\n  border-color: #c6d7ff;\n  color: #1f3b8f;\n}\n\n.register-step.active span {\n  background: #2f6fed;\n  color: #fff;\n}\n\n.form-cadastro-interno {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 20px;\n  padding: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n\n}\n\n.form-cadastro-interno .image-upload-container {\n  background-color: #f8f9fd;\n  border-radius: 10px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  height: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed var(--borda);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n\n  >input {\n    opacity: .3;\n    height: 100%;\n    width: 100%;\n    cursor: pointer;\n    z-index: 1;\n  }\n\n  >span {\n    position: absolute;\n    bottom: -40px;\n    font-weight: bold;\n    color: #292d32b4;\n  }\n\n\n}\n\n.form-cadastro-interno .image-upload-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-cadastro-interno .image-upload-label {\n  font-weight: bold;\n  color: #292d32b4;\n  margin-left: 10px;\n  font-size: 13px;\n}\n\n/* Quando a webcam está ativa, o container precisa crescer */\n.form-cadastro-interno .image-upload-container.webcam-active {\n  height: auto;\n  padding: 12px;\n  align-items: stretch;\n}\n\n.form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam {\n  width: 100%;\n}\n\n.form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam video {\n  max-height: 320px;\n  object-fit: cover;\n}\n\n.inclusion-step {\n  padding: 24px 30px 30px;\n}\n\n.inclusion-form .form-group {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.inclusion-section {\n  margin-bottom: 20px;\n}\n\n.inclusion-section h5 {\n  margin: 0 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--texto);\n  background: #f3f4f6;\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.inclusion-form .form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.inclusion-form label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--texto);\n}\n\n.inclusion-form input,\n.inclusion-form select {\n  border: 1px solid var(--borda);\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: var(--branco);\n}\n\n.inclusion-form textarea {\n  border: 1px solid var(--borda);\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: var(--branco);\n  resize: vertical;\n}\n\n.inclusion-textarea {\n  grid-column: 1 / -1;\n}\n\n.inclusion-upload {\n  background: #f7f9ff;\n  border: 1px dashed #cbd5f5;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 16px;\n}\n\n.inclusion-upload input[type=\"file\"] {\n  margin-top: 10px;\n}\n\n.inclusion-upload .image-upload-container {\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px dashed var(--borda);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  padding: 12px;\n}\n\n.inclusion-upload .image-upload-container.webcam-active {\n  min-height: unset;\n  align-items: stretch;\n}\n\n.inclusion-upload .image-upload-container img {\n  width: 50px;\n  height: 50px;\n  opacity: 0.5;\n}\n\n.inclusion-upload .image-upload-container .upload-icon {\n  position: static;\n}\n\n.inclusion-upload .image-upload-container>span {\n  color: #292d32b4;\n  font-weight: 600;\n  text-align: center;\n}\n\n.inclusion-upload .image-upload-container .preview-image {\n  position: static;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 190px;\n  object-fit: contain;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.inclusion-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.existing-file {\n  font-size: 13px;\n  margin: 6px 0 0;\n}\n\n.form-cadastro-interno .image-upload-container img {\n  width: 50px;\n  height: 50px;\n  opacity: 0.5;\n  position: absolute;\n  cursor: pointer;\n}\n\n.image-preview {\n  width: 100%;\n  height: 100%;\n  max-height: 250px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.image-upload-container .preview-image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain;\n  border-radius: 10px;\n  position: absolute;\n  z-index: 0;\n  background: #fff;\n}\n\n.form-cadastro-interno .form-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\n.form-cadastro-interno .form-group div {\n  display: flex;\n  flex-direction: column;\n  padding: 12px 15px;\n  border-radius: 8px;\n}\n\n.form-cadastro-interno .form-group label {\n  font-weight: bold;\n  color: #292d32b4;\n  margin-left: 10px;\n  font-size: 13px;\n  z-index: 1;\n}\n\n.btn-cadastrar-interno {\n  position: absolute;\n  top: 14px;\n  right: 20px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 16px;\n  padding: 6px 16px;\n  border: 1px solid var(--texto-destaque);\n  color: var(--texto-destaque);\n}\n\n.btn-action-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.btn-cadastrar-interno:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .form-cadastro-interno {\n    grid-template-columns: 1fr;\n    padding: 20px;\n    gap: 15px;\n  }\n\n  .form-cadastro-interno .image-upload-container {\n    max-width: 300px;\n    margin: 0 auto;\n    height: 200px;\n\n    >span {\n      margin-bottom: 15px;\n    }\n  }\n\n  .form-cadastro-interno .image-upload-container.webcam-active {\n    max-width: 100%;\n    height: auto;\n    padding: 12px;\n  }\n\n  .form-cadastro-interno .image-upload-container.webcam-active .image-upload-webcam video {\n    max-height: 220px;\n  }\n\n  .form-cadastro-interno .form-group {\n    grid-template-columns: 1fr;\n  }\n\n  .btn-cadastrar-interno {\n    position: static;\n    margin-top: 20px;\n    width: 100%;\n    justify-content: center;\n    border: none;\n    background-color: var(--texto-destaque);\n    color: var(--branco);\n    padding: 10px;\n    border-radius: 8px;\n    font-size: 18px;\n  }\n\n  .register-steps {\n    grid-template-columns: 1fr;\n    padding: 10px 16px;\n  }\n\n  .inclusion-form .form-group {\n    grid-template-columns: 1fr;\n  }\n\n  .inclusion-actions {\n    flex-direction: column;\n  }\n\n  .image-upload-actions .btn-primary,\n  .image-upload-actions .btn-secondary {\n    flex: 1 1 140px;\n  }\n}\n\n\n/* Container de conduta e regime do editar interno */\n.custom-regime-conduct-row {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n\n.custom-select-regime,\n.custom-select-conduct {\n  flex: 1;\n  padding: 10px;\n}\n\n\n/* Page internaldetails */\n.internal-details {\n  display: flex;\n  flex-direction: column;\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 24px;\n}\n\n.internal-details-skeleton {\n  padding: 8px 0;\n}\n\n.internal-accordion-skeleton {\n  padding: 14px 16px;\n}\n\n.accordion-empty-state {\n  margin: 12px 0;\n}\n\n.line {\n  display: flex;\n  width: 100%;\n}\n\n.first-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.profile-image-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  align-self: stretch;\n  flex: 0 0 220px;\n  gap: 10px;\n}\n\n.profile-image-wrapper {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  max-width: 220px;\n  max-height: 260px;\n  object-fit: cover;\n  border-radius: 20px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.arrival-meta-inline {\n  width: 100%;\n  max-width: 220px;\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n  border: 1px solid #c9d8ff;\n  border-radius: 14px;\n  padding: 10px 10px 10px 12px;\n  box-shadow: 0 8px 22px rgba(35, 86, 200, 0.14);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  position: relative;\n}\n\n.arrival-meta-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #2f4b8f;\n}\n\n.arrival-meta-content svg {\n  font-size: 18px;\n}\n\n.arrival-meta-content>div {\n  min-width: 0;\n  position: relative;\n}\n\n.arrival-meta-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #4766a8;\n}\n\n.arrival-meta-date {\n  display: block;\n  font-size: 15px;\n  color: #213a6c;\n}\n\n.arrival-meta-edit-btn {\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  right: -10px;\n  top: 10px;\n  border: none;\n  color: #2f6fed;\n  cursor: pointer;\n}\n\n.arrival-meta-edit-btn:hover {\n  transform: translateY(-1px);\n}\n\n.arrival-meta-edit-btn svg {\n  font-size: 13px;\n}\n\n.arrival-date-popover {\n  position: absolute;\n  bottom: calc(100% + 14px);\n  left: 62%;\n  transform: translateX(-36%);\n  width: 360px;\n  max-width: calc(100vw - 32px);\n  background: #ffffff;\n  border: 1px solid #d7e3ff;\n  border-radius: 16px;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);\n  padding: 14px;\n  z-index: 99999;\n}\n\n.arrival-date-popover-arrow {\n  position: absolute;\n  bottom: -9px;\n  left: 42%;\n  width: 18px;\n  height: 18px;\n  background: #ffffff;\n  border-right: 1px solid #d7e3ff;\n  border-bottom: 1px solid #d7e3ff;\n  transform: translateX(-50%) rotate(45deg);\n}\n\n.arrival-date-popover-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  color: #213a6c;\n}\n\n.arrival-date-popover-header strong {\n  font-size: 15px;\n}\n\n.arrival-date-popover-close {\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 50%;\n  background: #f2f5fb;\n  color: #475569;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.arrival-date-popover-body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.arrival-date-popover-body label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4766a8;\n  text-transform: uppercase;\n}\n\n.arrival-date-popover-body input {\n  width: 100%;\n  border: 1px solid #c9d8ff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: #1f2a3a;\n  background: #f8fbff;\n}\n\n.arrival-date-popover-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.arrival-date-cancel-btn,\n.arrival-date-save-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 9px 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.arrival-date-cancel-btn {\n  background: #f2f5fb;\n  color: #475569;\n}\n\n.arrival-date-save-btn {\n  background: #2f6fed;\n  color: #ffffff;\n}\n\n.basic-info,\n.additional-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border-radius: 8px;\n  flex: 1 1 280px;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.basic-info p,\n.additional-info p {\n  display: block;\n  background-color: var(--fundo);\n  color: var(--texto);\n  font-weight: 500;\n  padding: 8px 12px;\n  border-radius: 12px;\n  min-height: 44px;\n  line-height: 1.4;\n  overflow-wrap: break-word;\n  word-break: normal;\n  white-space: normal;\n\n  >strong {\n    display: block;\n    font-size: 14px;\n    color: #292d32b4;\n    margin-bottom: 2px;\n  }\n}\n\n@media (max-width: 860px) {\n  .first-line {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .profile-image-container,\n  .basic-info,\n  .additional-info {\n    flex: 1 1 auto;\n    width: 100%;\n    max-width: 420px;\n    margin: 0 auto;\n    box-sizing: border-box;\n  }\n\n  .profile-image {\n    max-width: 180px;\n    max-height: 220px;\n  }\n\n  .arrival-meta-inline {\n    max-width: 180px;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-image-container,\n  .basic-info,\n  .additional-info {\n    max-width: 100%;\n  }\n\n  .basic-info,\n  .additional-info {\n    padding: 12px;\n  }\n}\n\n.second-line {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 10px;\n  margin: 0;\n}\n\n.status-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--fundo);\n  border-radius: 8px;\n  text-align: center;\n  padding: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);\n  >strong, p{\n    font-size: 13px;\n  }\n}\n\n.status-box-full-width {\n  width: 100%;\n  max-width: 220px;\n}\n\n.visit-flag {\n  display: inline-block;\n  padding: 4px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  background: var(--ui-surface);\n  cursor: pointer;\n  transition: opacity 0.15s ease, box-shadow 0.15s ease;\n}\n\n.visit-flag--liberado {\n  color: var(--verde);\n  border: 1px solid var(--verde);\n  box-shadow: 0 0 0 3px rgba(0, 121, 50, 0.12), 0 2px 8px rgba(0, 121, 50, 0.18);\n}\n\n.visit-flag--bloqueado {\n  color: var(--Vermelho);\n  border: 1px solid var(--Vermelho);\n  box-shadow: 0 0 0 3px rgba(180, 30, 30, 0.12), 0 2px 8px rgba(180, 30, 30, 0.18);\n}\n\n.visit-flag:hover:not(:disabled) {\n  opacity: 0.7;\n}\n\n.visit-flag:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.third-line {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding-bottom: 40px;\n\n  >h3 {\n    color: var(--texto-destaque);\n  }\n}\n\n.images-grid {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.image-thumbnail {\n  width: 150px;\n  height: 150px;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.image-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n/* Galeria do detalhe do interno: miniatura + legenda (título, descrição e data) */\n.images-grid--captioned {\n  align-items: flex-start;\n}\n\n.image-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 150px;\n}\n\n.image-caption {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 0 4px;\n  font-size: 0.78rem;\n  line-height: 1.3;\n  color: var(--texto);\n}\n\n.image-caption-title {\n  color: var(--texto-destaque);\n  font-size: 0.82rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.image-caption-description {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.image-caption-title.is-empty,\n.image-caption-description.is-empty {\n  color: var(--ui-muted);\n  font-style: italic;\n  font-weight: normal;\n}\n\n.image-main-btn {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n  border: 1px solid #cfe0ff;\n  background: rgba(246, 249, 255, 0.95);\n  color: #2b5fd9;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 6px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.image-main-btn:hover {\n  background: #e9f0ff;\n}\n\n.image-main-btn:focus-visible {\n  outline: 2px solid #2b5fd9;\n  outline-offset: 2px;\n}\n\n.image-actions-container {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n  display: flex;\n  align-items: space-between;\n  justify-content: space-between;\n  gap: 8px;\n  z-index: 2;\n}\n\n.image-actions-container .image-main-btn {\n  position: static;\n  flex: 1;\n  margin: 0;\n}\n\n.image-main-icon-btn {\n  flex: 0 0 34px !important;\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid #d7c9ff;\n  background: rgba(248, 245, 255, 0.95);\n  color: #7b61c9;\n}\n\n.image-main-icon-btn:hover {\n  background: #f1ebff;\n}\n\n.image-main-icon-btn.is-main {\n  border-color: #ffc7cf;\n  background: rgba(255, 240, 243, 0.98);\n  color: #e63946;\n}\n\n.image-main-icon-btn.is-main:hover {\n  background: #ffe4e8;\n}\n\n.image-main-icon-btn svg {\n  font-size: 15px;\n}\n\n.image-delete-btn {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ffd1d1;\n  background: rgba(255, 245, 245, 0.95);\n  color: #d62828;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.image-delete-btn:hover {\n  background: #ffe7e7;\n}\n\n.image-delete-btn:focus-visible {\n  outline: 2px solid #d62828;\n  outline-offset: 2px;\n}\n\n.add-image-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 10px 15px;\n  border: 1px dashed var(--azul);\n  background-color: var(--fundo);\n  border-radius: 20px;\n  width: 140px;\n  min-height: 140px;\n  cursor: pointer;\n}\n\n\n.visitor-thumbnail {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.large-image-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  overflow-y: auto;\n}\n\n.large-image {\n  max-width: 90%;\n  max-height: 90vh;\n  border-radius: 8px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n}\n\n.large-image-details {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 10px;\n  border-radius: 5px;\n  max-width: 80%;\n}\n\n\n.internal-details .div-dados .dados-gerais {\n  display: flex;\n}\n\n.internal-details .div-dados .dados-gerais>div {\n  width: 50%;\n}\n\n@media (max-width: 768px) {\n\n  /* Linha 1: Imagem e Dados Principais */\n  .first-line {\n    gap: 0;\n  }\n\n  .profile-image-container {\n    padding: 0;\n  }\n\n  .profile-image {\n    width: 250px;\n    height: 250px;\n    margin: 20px auto;\n  }\n\n  .arrival-meta-inline {\n    max-width: 250px;\n  }\n\n  /* Linha 2: Caixas de Status */\n  .second-line {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin: 20px 0;\n  }\n\n  /* Linha 3: Imagens anexadas */\n  .images-grid {\n    justify-content: center;\n  }\n\n  .image-thumbnail,\n  .add-image-btn {\n    width: 100px;\n    height: 100px;\n  }\n\n  .image-card {\n    width: 100px;\n  }\n\n  .content-btn-edit {\n    text-align: center;\n  }\n}\n\n.btn-delete-icon {\n  margin-left: 10px;\n  font-size: 16px;\n  ;\n}\n\n.content-btn-edit {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n  >button {\n    background: transparent;\n    border: 1px solid var(--texto-destaque);\n    color: var(--texto-destaque);\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 14px;\n    padding: 6px 12px;\n  }\n}\n\n.dados-gerais table td button,\n.table-home table td a {\n  background: none;\n  color: var(--azul-escuro);\n  font-size: 16px;\n}\n\n.title-accordion {\n  cursor: pointer;\n}\n\n.icon-accordion {\n  float: right;\n  font-size: 20px;\n}\n\n.unit-summary-inline {\n  float: right;\n  margin-right: 12px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #4b5668;\n}\n\n/* Resumo da unidade no título do acordeon \"Dados Gerais\": ao ficar\n   flutuante (float: right) e quebrar em mais de uma linha, sua altura\n   não é contabilizada pelo h4, e o conteúdo do acordeon logo abaixo\n   (caixa de Status) acaba sobrepondo o texto. Vira bloco próprio\n   abaixo do título nas telas estreitas para não sobrepor. Essa regra\n   precisa vir depois da declaração base de .unit-summary-inline acima\n   (mesma especificidade) para não ser sobrescrita por ela na cascata. */\n@media (max-width: 768px) {\n  .unit-summary-inline {\n    float: none;\n    display: block;\n    width: 100%;\n    margin: 6px 0 0;\n    text-align: left;\n  }\n}\n\n.icoFile {\n  cursor: pointer;\n  color: var(--azul);\n  font-size: 20px;\n}\n\n.doc-description {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #4b5668;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.temporary-leaving-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 96px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n.temporary-leaving-status.returned {\n  background: #e9f8ef;\n  border-color: #b8ebcd;\n  color: #1e7d47;\n}\n\n.temporary-leaving-status.active {\n  background: #f3ebff;\n  border-color: #d9c3ff;\n  color: #6a42b9;\n}\n\n.temporary-leaving-status.inactive {\n  background: #f2f4f8;\n  border-color: #d7dce8;\n  color: #4f5c74;\n}\n\n/* Cntainer do botao de addcionar algo com a logica do visbledAccess */\n.container-visibledAccess {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 0;\n}\n\n.internal-details-page .content+.content {\n  margin-top: 16px;\n}\n\n.content--trabalho.open {\n  max-height: 800px;\n  overflow-y: auto;\n}\n\n.content--trabalho .title-accordion {\n  position: sticky;\n  top: 0;\n  background-color: var(--ui-surface);\n  z-index: 10;\n  margin: -16px -16px 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--ui-border, #e5e7eb);\n}\n\n.discipline-timeline.visit-history-timeline {\n  max-height: 600px;\n}\n\n.visit-history-timeline .timeline-dot-discipline {\n  background: var(--verde);\n}\n\n\n/* Css do formulario de edicao de telefone em linha */\n\n.inline-form {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.inline-form .form-edit {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n\n.form-edit .form-input {\n  width: 20rem;\n}\n\n.btn-edit-inline {\n  transform: translateY(25%);\n  border: 1px solid var(--azul) !important;\n  padding: 10px !important;\n  width: 80px;\n}\n\n\n/* TD de adcionar processo */\n.btn-proccess {\n  position: relative;\n  cursor: pointer;\n  color: var(--azul-escuro) !important;\n  font-size: 16px;\n}\n\n.btn-proccess:hover span {\n  display: block;\n}\n\n.btn-proccess>span {\n  position: absolute;\n  display: none;\n  bottom: 0;\n  left: -130px;\n  font-size: 10px !important;\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 10px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 3px 0px var(--azul);\n  background-color: var(--branco);\n  z-index: 3;\n}\n\n.td-table-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n\n/* Csstd aka */\n.td-vulgo {\n  display: flex;\n  flex-direction: column;\n}\n\n\n/* css botoes AKA */\n.edit-internal-container {\n  padding: 20px;\n}\n\n.aka-input {\n  width: 100%;\n  display: flex;\n  flex-direction: row !important;\n  align-items: center;\n  justify-content: center;\n  padding: 0 !important;\n  margin-bottom: 10px;\n\n  /* >input {\n    width: 90% !important;\n  } */\n\n  >button {\n    width: 10% !important;\n    background-color: transparent;\n    color: var(--Vermelho);\n    font-size: 22px;\n    border: none;\n  }\n}\n\n.add-aka-btn {\n  background-color: var(--verde);\n  letter-spacing: .5px;\n  color: #fff;\n  border: none;\n}\n\n\n/* Tooltipe de acoes da tabela */\n.actions-container {\n  position: relative;\n  display: inline-block;\n  border-radius: 8px;\n}\n\n.btn-actions {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  background-color: var(--azul-escuro);\n}\n\n.actions-menu {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 20px;\n  right: 0;\n  background: #fff;\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  min-width: 120px;\n  border-radius: 4px;\n}\n\n.actions-menu .action-item {\n  padding: 10px;\n  text-align: left;\n  display: block;\n  text-transform: uppercase;\n  font-weight: 600 !important;\n  font-size: 12px;\n  color: var(--azul-escuro);\n  cursor: pointer;\n  border-bottom: 1px solid var(--borda);\n  border-radius: 0;\n  z-index: 9999;\n}\n\n.actions-menu .action-item:hover {\n  background-color: #f1f1f1;\n}\n\n\n/* liberation.css */\n.liberation-submit {\n  background-color: var(--verde);\n  width: 100%;\n  font-size: 16px;\n}\n\n\n/* Css detalhes de cadastro de servico social */\n.social-container {\n  .content-topo {\n    display: flex;\n    gap: 20px;\n    padding-bottom: 40px;\n\n    .content-img>img {\n      border-radius: 20px;\n      width: 200px;\n      height: 250px;\n      object-fit: cover;\n    }\n\n    .content-itens {\n      display: flex;\n      gap: 20px;\n      width: 100%;\n\n      >div {\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n\n        >p {\n          display: flex;\n          flex-direction: column;\n          font-weight: 500;\n          background-color: #fff;\n          padding: 6px;\n          border-radius: 12px;\n          min-height: 50px;\n\n          >strong {\n            color: #292d32b4;\n          }\n        }\n      }\n    }\n  }\n}\n\n.social-form-busca-interno {\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n\n  >div {\n    width: 40%;\n\n  }\n\n  >select {\n    width: 100px;\n  }\n\n}\n\n\n.social-submit-button {\n  margin-top: 10px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 20px;\n  background-color: var(--azul);\n  color: #fff;\n  cursor: pointer;\n}\n\n.social-tabs {\n  display: flex;\n}\n\n.social-tab-button {\n  padding: 10px 30px;\n  border: none;\n  border-radius: 4px 4px 0 0;\n  background-color: transparent;\n  color: #292d32b4;\n  font-size: 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #292d32b4;\n}\n\n.social-tab-button.active {\n  border-bottom: 2px solid var(--azul);\n  color: var(--texto-destaque);\n}\n\n.social-tab-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 0 0 8px 8px;\n  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */\n}\n\n.social-form-group {\n  flex: 1;\n  margin-bottom: 20px;\n}\n\n\n.social-form-group-duplo {\n  display: flex;\n  gap: 20px;\n\n  >div>select,\n  >div>input {\n    margin: 0;\n    padding: 15px;\n    border: none;\n    border-radius: 20px;\n  }\n}\n\n.arquivo-incluso {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--azul);\n\n  >a {\n    color: var(--azul);\n  }\n}\n\n.social-form-group-duplo label {\n  flex: 1;\n}\n\n.social-form-group-duplo select,\n.social-form-group-duplo input {\n  flex: 1;\n  margin-left: 10px;\n  background-color: var(--fundo);\n  color: var(--ui-text);\n}\n\n.social-form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.social-required-indicator {\n  color: #d32f2f;\n  font-weight: 700;\n}\n\n.required-indicator {\n  color: #d32f2f;\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n.social-form-group input,\n.social-form-group select,\n.social-form-group textarea {\n  width: 100%;\n  padding: 16px;\n  border-radius: 20px;\n  border: 1px solid var(--borda);\n  background-color: var(--fundo);\n  color: var(--ui-text);\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Renderizacao de serviso social em internaldetails */\n.social-service-details {\n  margin-top: 20px;\n\n  >h4 {\n    margin-top: 40px;\n  }\n\n  >div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-bottom: 10px;\n\n    >div {\n      border-radius: 10px;\n      flex: 1 1 calc(33.333% - 20px);\n      padding: 8px;\n      background-color: var(--fundo);\n      color: var(--texto);\n    }\n  }\n}\n\n.admission-health-details {\n  margin-top: 20px;\n}\n\n.admission-health-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 12px;\n}\n\n.admission-health-card {\n  background: #f5f8ff;\n  border: 1px solid #e3e9f6;\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.admission-health-card h5 {\n  margin: 0 0 6px;\n  font-size: 12px;\n  color: #3b4a66;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.admission-health-card p {\n  margin: 0;\n  color: #1f2a3a;\n  font-size: 14px;\n  word-break: break-word;\n}\n\n.admission-health-card--wide {\n  grid-column: 1 / -1;\n}\n\n.inclusion-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px 10px 4px;\n}\n\n.inclusion-timeline-item {\n  border: 1px solid #e3e9f6;\n  background: #f8faff;\n  border-radius: 12px;\n  padding: 12px 14px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.inclusion-timeline-item:hover {\n  border-color: #c6d7ff;\n  background: #eef4ff;\n}\n\n.inclusion-timeline-item:focus-visible {\n  outline: 2px solid #2f6fed;\n  outline-offset: 2px;\n}\n\n.inclusion-timeline-date {\n  font-weight: 700;\n  color: #1f2a3a;\n}\n\n.inclusion-timeline-meta {\n  display: flex;\n  gap: 14px;\n  color: #3b4a66;\n  font-size: 13px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.inclusion-quick-view-btn {\n  padding: 4px 10px;\n  font-size: 12px;\n}\n\n\n.arquivo {\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n\n  >a {\n    width: 45px;\n    height: 45px;\n    padding: 9px;\n    border: 1.2px solid var(--texto-destaque);\n    border-radius: 6px;\n    font-size: 14px;\n    color: var(--texto-destaque);\n    font-weight: 600;\n\n    >img {\n      margin-bottom: 7px;\n    }\n  }\n}\n\n\n.social-service-details h5 {\n  font-size: 14px;\n  font-weight: bold;\n  color: #292d32b4;\n  margin-bottom: 5px;\n}\n\n.aka-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin: 4px 20px 0;\n\n  span {\n    background: var(--texto-destaque);\n    color: white;\n    padding: 2px 10px;\n    border-radius: 5px;\n    font-size: 10px;\n\n    button {\n      font-size: 14px !important;\n      border: none;\n      padding: 0;\n      color: white;\n      margin-left: 5px;\n      transform: translateY(1px);\n    }\n  }\n}\n\n\n/* Estilos Gerais */\n.evolucao-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n\n.social-form-group label {\n  font-weight: bold;\n  margin-bottom: 10px;\n  display: block;\n  color: var(--texto-destaque);\n}\n\n.social-form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--borda);\n  border-radius: 8px;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n  resize: none;\n}\n\n.social-submit-button {\n  background-color: var(--verde);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  font-weight: bold;\n  margin-top: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n\n/* Linha do Tempo */\n.timeline {\n  flex: 2;\n  padding: 20px;\n  border-radius: 8px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n  position: relative;\n}\n\n.timeline h4 {\n  font-size: 18px;\n  margin-bottom: 20px;\n  font-weight: bold;\n  color: var(--texto-destaque);\n}\n\n.timeline-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n}\n\n.timeline-list::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 20px;\n  bottom: 0;\n  width: 2px;\n  background-color: var(--borda);\n}\n\n.timeline-item {\n  margin-bottom: 20px;\n  position: relative;\n  padding-left: 40px;\n}\n\n.timeline-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 13px;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: var(--verde);\n  box-shadow: 0 0 0 5px #fff;\n}\n\n.timeline-date {\n  font-size: 14px;\n  font-weight: bold;\n  color: #777;\n  margin-bottom: 5px;\n}\n\n.timeline-content {\n  border-radius: 8px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  font-size: 14px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px;\n\n  >p {\n    flex: 1 1 calc(33.333% - 20px);\n    color: var(--texto);\n    display: flex;\n    flex-direction: column;\n    background: var(--fundo);\n    padding: 10px;\n    font-weight: 600;\n\n    >strong {\n      color: #292d32b4;\n    }\n  }\n}\n\n\n/* Enderecos no serviso social */\n.address-tab-content {\n  margin-top: 20px;\n}\n\n.add-address-button {\n  background-color: var(--verde) !important;\n  color: #fff !important;\n  padding: 10px !important;\n  margin-bottom: 20px;\n  border: none;\n}\n\n.edit-address-button {\n  color: var(--azul);\n  font-size: 20px;\n\n}\n\n/* bursca de pais e cidade */\n.form-field {\n  position: relative;\n}\n\n.cpf-searching {\n  margin-left: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #4c6fff;\n}\n\n.form-field .suggestions-list {\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  max-height: 200px;\n  min-width: 200px;\n  overflow-y: auto;\n  background-color: white;\n  position: absolute;\n  bottom: 10px;\n  left: 30px;\n  z-index: 1000;\n}\n\n.form-field .suggestions-list-cities {\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  max-height: 200px;\n  min-width: 200px;\n  overflow-y: auto;\n  background-color: white;\n  position: absolute;\n  top: 75px;\n  left: 30px;\n  z-index: 1000;\n}\n\n.form-field .suggestions-list li,\n.form-field .suggestions-list-cities li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.form-field .suggestions-list li:hover,\n.form-field .suggestions-list-cities li:hover {\n  background-color: #f0f0f0;\n}\n\n.form-field .suggestions-list-cities.process-field-suggestions {\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 100%;\n  max-width: 100%;\n}\n\n.address-modal-form .modal-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n}\n\n.address-modal-form .field-half {\n  grid-column: span 1;\n}\n\n.address-modal-form .field-full {\n  grid-column: 1 / -1;\n}\n\n.address-modal-form .modal-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.address-modal-form .modal-form-actions .btn-edit {\n  min-width: 140px;\n}\n\n.temporary-return-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 6px 10px 2px;\n}\n\n.temporary-return-form .modal-form {\n  margin-bottom: 0;\n}\n\n.temporary-return-form .modal-form input[readonly] {\n  background: #f5f7fc;\n  color: #30405f;\n}\n\n.temporary-return-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.temporary-return-actions .btn-edit,\n.temporary-return-actions .save-btn {\n  min-width: 160px;\n}\n\n\n/* Link de quando o interno tem outro cadastro */\n.other-internal {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--vermelho2);\n  border: 1px solid var(--Vermelho);\n  animation: blink 0.3s ease-in-out 4;\n\n  >a, >span {\n    color: var(--Vermelho);\n    padding: 10px 10%;\n    text-transform: uppercase;\n    text-align: center;\n  }\n}\n\n.link-internal-section {\n  margin-top: 24px;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #f9fafb;\n}\n\n.link-internal-title {\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.link-internal-info {\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 14px;\n  line-height: 1.5;\n}\n\n.link-internal-current {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  color: #374151;\n}\n\n.link-internal-unlink-btn {\n  background: none;\n  border: 1px solid var(--Vermelho);\n  color: var(--Vermelho);\n  border-radius: 4px;\n  padding: 4px 12px;\n  font-size: 12px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: var(--vermelho2);\n  }\n}\n\n.link-internal-search {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.link-internal-selected {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #374151;\n  flex-wrap: wrap;\n}\n\n.other-internal--green {\n  background-color: #d4edda;\n  border-color: var(--verde);\n  animation: blink 0.3s ease-in-out 4;\n\n  >a, >span {\n    color: var(--verde);\n  }\n}\n\n.other-internal-info {\n  width: 100%;\n  padding: 6px 5%;\n  background-color: #f0f4f0;\n  color: #4a6b4a;\n  font-size: 12px;\n  text-align: center;\n}\n\n.other-internal-warning {\n  width: 100%;\n  padding: 8px 5%;\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  color: #856404;\n  font-size: 13px;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 600;\n\n  >a {\n    color: #856404;\n    text-decoration: underline;\n    font-weight: 700;\n  }\n}\n\n.internal-type-flag {\n  display: inline-block;\n  padding: 4px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.internal-type-flag--principal {\n  background-color: #d4edda;\n  color: var(--verde);\n  border: 1px solid var(--verde);\n}\n\n.internal-type-flag--secundario {\n  background-color: var(--vermelho2);\n  color: var(--Vermelho);\n  border: 1px solid var(--Vermelho);\n}\n\n.save-btn {\n  background-color: var(--verde);\n  color: white;\n  border: none;\n}\n\n/* Definição da animação */\n@keyframes blink {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n}\n\n/* Ajustes de responsividade */\n\n@media (max-width: 1200px) {}\n\n@media (max-width: 992px) {\n  .social-form-busca-interno {\n    flex-direction: row !important;\n    align-items: center;\n    justify-content: center;\n\n    >div {\n      width: 60% !important;\n    }\n\n    >select {\n      width: 40%;\n    }\n  }\n\n  .social-form-group-duplo {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .address-modal-form .modal-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .address-modal-form .field-half,\n  .address-modal-form .field-full {\n    grid-column: 1 / -1;\n  }\n\n  .address-modal-form .modal-form-actions .btn-edit {\n    width: 100%;\n  }\n\n  .social-tabs {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .social-tab-button {\n    flex: 1 1 100%;\n    text-align: center;\n  }\n\n  .btn-h2 {\n    flex-direction: column;\n    align-items: flex-start;\n\n    >h2 {\n      margin-bottom: 10px;\n    }\n  }\n\n  .social-service-details div {\n    flex: 1 1 100%;\n  }\n\n  .social-submit-button {\n    width: 100%;\n    padding: 15px;\n    font-size: 16px;\n  }\n\n  .timeline {\n    padding: 15px;\n  }\n\n  .timeline-item {\n    padding-left: 20px;\n  }\n\n  .timeline-list::before {\n    left: 10px;\n  }\n\n  .timeline-item::before {\n    left: 3px;\n  }\n}\n\n@media (max-width: 768px) {\n  .social-form-busca-interno {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n\n    >div {\n      width: 100%;\n    }\n\n    >select {\n      width: 100%;\n    }\n  }\n\n  .social-tabs {\n    flex-direction: column;\n  }\n\n  .social-tab-button {\n    width: 100%;\n    padding: 15px;\n  }\n\n  .social-tab-content {\n    padding: 15px;\n  }\n\n  .social-form-group-duplo {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .timeline {\n    padding: 10px;\n  }\n\n  .timeline-item {\n    padding-left: 15px;\n  }\n\n  .timeline-list::before {\n    left: 8px;\n  }\n\n  .timeline-item::before {\n    left: 0;\n  }\n}\n\n@media (max-width: 576px) {\n  .btn-h2 {\n    align-items: center;\n    text-align: center;\n  }\n\n  .btn-h2 h2 {\n    font-size: 18px;\n  }\n\n  .social-form-group textarea {\n    padding: 10px;\n  }\n\n  .social-submit-button {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .social-service-details div {\n    padding: 10px;\n  }\n\n  .timeline {\n    padding: 10px;\n  }\n\n  .timeline-content {\n    font-size: 12px;\n  }\n}\n\n\n\n/* Busca do Processo */\n.process-search-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.process-search-container input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid var(--borda);\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.process-search-results {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  z-index: 1000;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.process-search-results-capitulation {\n  width: 100%;\n  top: calc(100% + 2px);\n  left: 0;\n}\n\n.process-search-results div {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.process-search-results div:hover {\n  background-color: var(--fundo);\n  color: var(--texto-destaque);\n}\n\n.process-capitulation-input {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  position: relative;\n}\n\n.process-capitulation-input input {\n  flex: 1;\n}\n\n.process-search-loading {\n  display: inline-block;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #4c6fff;\n}\n\n.process-capitulation-add {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid var(--borda);\n  background: #f7f9ff;\n  color: var(--texto-destaque);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.process-capitulation-add:hover {\n  background: #eef3ff;\n}\n\n.processes-table {\n  table-layout: auto;\n  min-width: 920px;\n}\n\n.processes-table .process-col-court,\n.processes-table .process-col-capitulation {\n  white-space: normal !important;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  vertical-align: top;\n}\n\n.processes-table th.process-col-court,\n.processes-table td.process-col-court {\n  min-width: 220px;\n  max-width: 260px;\n}\n\n.processes-table th.process-col-capitulation,\n.processes-table td.process-col-capitulation {\n  min-width: 300px;\n  max-width: 380px;\n}\n\n.process-capitulation-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.process-capitulation-item {\n  line-height: 1.35;\n}\n\n@media (max-width: 1024px) {\n  .processes-table {\n    min-width: 860px;\n  }\n\n  .processes-table th.process-col-court,\n  .processes-table td.process-col-court {\n    min-width: 180px;\n    max-width: 220px;\n  }\n\n  .processes-table th.process-col-capitulation,\n  .processes-table td.process-col-capitulation {\n    min-width: 260px;\n    max-width: 320px;\n  }\n}\n\n.social-service-layout {\n  background: #ffffff;\n  border: 1px solid #e4e9f6;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);\n  margin-top: 12px;\n}\n\n.social-service-layout .social-tabs {\n  margin-top: 0;\n}\n\n.social-service-layout .social-tab-content {\n  margin-top: 12px;\n}\n\n\n/* ===============================\n   Webcam / Upload de imagem (RegisterInternal)\n   =============================== */\n\n/* Wrapper quando a webcam está ativa */\n.image-upload-webcam {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Preview da webcam */\n.image-upload-webcam video {\n  width: 100%;\n  border-radius: 10px;\n}\n\n/* Ações da webcam (botões) */\n.image-upload-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Botão padrão secundário (usar arquivos) */\n.btn-secondary {\n  background-color: var(--fundo);\n  border: 1px solid var(--texto-destaque);\n  color: var(--texto-destaque);\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* Botão de ação principal (tirar foto) */\n.btn-primary {\n  background-color: var(--texto-destaque);\n  border: none;\n  color: var(--branco);\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* Mensagem de erro da câmera */\n.camera-error {\n  font-size: 13px;\n  color: var(--Vermelho);\n  text-align: center;\n}\n\n/* \n   AddImage - botão \"Clique para abrir câmera ou selecionar arquivo\"\n    */\n\n.input-visual {\n  width: 100%;\n  min-height: 52px;\n  padding: 14px 16px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: var(--fundo);\n  border: 1px dashed var(--borda);\n  border-radius: 12px;\n\n  color: var(--texto-destaque);\n  font-weight: 600;\n  text-align: center;\n\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n/* Efeito hover */\n.input-visual:hover {\n  border-color: var(--texto-destaque);\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n/* Foco via teclado (tab) */\n.input-visual:focus {\n  outline: none;\n  border-color: var(--texto-destaque);\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);\n}\n\n/* Texto interno */\n.input-visual span {\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .input-visual {\n    min-height: 48px;\n    padding: 12px 14px;\n  }\n}\n\n/*\n   AddImage - botão \"Clique para abrir câmera ou selecionar arquivo\"\n   */\n\n.input-error-text {\n  color: red;\n  font-size: 12px;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n.input-visual {\n  width: 100%;\n  min-height: 52px;\n  padding: 14px 16px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: var(--fundo);\n  border: 1px dashed var(--borda);\n  border-radius: 12px;\n\n  color: var(--texto-destaque);\n  font-weight: 600;\n  text-align: center;\n\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n/* Efeito hover */\n.input-visual:hover {\n  border-color: var(--texto-destaque);\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n/* Foco via teclado (tab) */\n.input-visual:focus {\n  outline: none;\n  border-color: var(--texto-destaque);\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);\n}\n\n/* Texto interno */\n.input-visual span {\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .input-visual {\n    min-height: 48px;\n    padding: 12px 14px;\n  }\n}\n\n/* Novos estilos para campos em linha nos modais */\n.form-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.form-field-small {\n  flex: 1;\n  min-width: 80px;\n}\n\n.form-field-half {\n  flex: 1;\n  min-width: 200px;\n}\n\n/* Botões de ação nas tabelas de Processo e Execução Penal */\n.btn-action-edit,\n.btn-action-view {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  margin-right: 12px;\n  /* Adiciona o espaço entre os ícones */\n  font-size: 16px;\n  transition: opacity 0.2s;\n}\n\n.btn-action-edit:hover,\n.btn-action-view:hover {\n  opacity: 0.7;\n}\n\n.btn-action-edit {\n  color: var(--azul-escuro);\n}\n\n.btn-action-view {\n  color: var(--azul);\n}\n\n/* Prévia do Interno no Agendamento */\n.appointment-internal-preview {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #f8f9fd;\n  padding: 12px;\n  border-radius: 12px;\n  margin-top: 8px;\n  border: 1px solid #e4e8f2;\n}\n\n.appointment-internal-image-preview {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--azul);\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.appointment-internal-info-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.appointment-internal-info-preview strong {\n  font-size: 14px;\n  color: var(--texto);\n}\n\n.appointment-internal-info-preview span {\n  font-size: 12px;\n  color: #666;\n}\n\n/* Grid de Agendamentos do Advogado */\n.appointments-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 20px 0;\n}\n\n.appointment-card {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e8edf2;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.appointment-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06);\n}\n\n.appointment-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f4f8;\n  flex-wrap: nowrap;\n  /* Garante que o badge não quebre para a linha de baixo */\n  min-height: 40px;\n  /* Garante espaço mínimo para o cabeçalho */\n}\n\n.appointment-card-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: var(--azul-escuro);\n  white-space: normal;\n  flex: 1;\n  margin-right: 10px;\n  line-height: 1.4;\n}\n\n.appointment-status-badge {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.status-active {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.status-done {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.status-canceled {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.status-expired {\n  background: #dc2626;\n  color: #ffffff;\n}\n\n.status-pending {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.status-warning {\n  background: #fed7aa;\n  color: #9a3412;\n}\n\n/* Header do card de agendamento de advogado */\n.adv-card-header {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f4f8;\n  margin-bottom: 4px;\n}\n\n.adv-card-badge-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 6px;\n}\n\n.adv-card-header-info {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n}\n\n.adv-card-internal-name {\n  margin: 0 0 2px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--azul-escuro);\n  line-height: 1.3;\n}\n\n.adv-card-lawyer-block {\n  display: flex;\n  flex-direction: column;\n  margin-top: 6px;\n}\n\n.adv-card-lawyer-label {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n  line-height: 1.2;\n}\n\n.adv-card-lawyer-name {\n  font-size: 11px;\n  color: var(--ui-muted);\n  line-height: 1.3;\n}\n\n.adv-card-unit-name {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: var(--ui-muted);\n  line-height: 1.3;\n  font-style: italic;\n}\n\n/* Observação em bloco */\n.adv-observation {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 8px;\n  background: #f8fafc;\n  border-left: 3px solid #94a3b8;\n  border-radius: 4px;\n}\n\n.adv-observation strong {\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.adv-observation p {\n  margin: 0;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* Motivo cancelamento em bloco */\n.adv-cancel-reason {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 8px;\n  background: #fff1f2;\n  border-left: 3px solid #b91c1c;\n  border-radius: 4px;\n}\n\n.adv-cancel-reason strong {\n  font-size: 11px;\n  color: #b91c1c;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.adv-cancel-reason p {\n  margin: 0;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* Tags de tipo de atendimento */\n.tag-presencial {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.tag-virtual {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.appointment-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-grow: 1;\n}\n\n.appointment-info-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  word-break: break-word;\n  /* Garante que o texto quebre */\n  white-space: normal;\n  /* Permite que o texto quebre */\n}\n\n.appointment-info-item strong {\n  flex-shrink: 0;\n  /* Impede que o label encolha */\n  margin-right: 8px;\n  /* Espaço entre label e valor */\n}\n\n.appointment-card-footer {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n.btn-action-complete {\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #a7f3d0;\n}\n\n.btn-action-complete:hover {\n  background: #bbf7d0;\n}\n\n.btn-authorized-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #15803d;\n  padding: 4px 0;\n}\n\n.appointment-info-item strong {\n  color: #64748b;\n}\n\n.appointment-info-item span {\n  color: var(--texto);\n  font-weight: 500;\n}\n\n/* process is_active toggle */\n.checkbox-label-process {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.process-active-toggle {\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin-bottom: 16px;\n  border: 1px solid;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.process-active-toggle--active {\n  background-color: #f0fdf4;\n  border-color: #86efac;\n}\n\n.process-active-toggle--inactive {\n  background-color: #fff7ed;\n  border-color: #fdba74;\n}\n\n.process-active-toggle__label {\n  margin-bottom: 0;\n}\n\n.process-active-toggle__status {\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.process-active-toggle--active .process-active-toggle__status {\n  color: #15803d;\n}\n\n.process-active-toggle--inactive .process-active-toggle__status {\n  color: #c2410c;\n}\n\n.process-active-toggle__hint {\n  font-size: 0.78rem;\n  color: #64748b;\n  margin-left: 24px;\n}\n\n/* process status (readOnly) */\n.process-status-label {\n  display: inline-block;\n  padding: 3px 12px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.process-status-active {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.process-status-inactive {\n  background-color: #ffedd5;\n  color: #c2410c;\n}\n\n/* ==========================================================================\n   Fluxo unificado de entrada (unifiedEntry.js)\n   Usa os tokens --ui-* já definidos em src/index.css como base do visual novo.\n   ========================================================================== */\n.unified-entry {\n  padding: 8px 4px 24px;\n}\n\n.unified-entry__header {\n  margin-bottom: 20px;\n}\n\n.unified-entry__header h2 {\n  margin: 0 0 4px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--ui-text);\n}\n\n.unified-entry__header p {\n  margin: 0;\n  color: var(--ui-muted);\n  font-size: 0.9rem;\n}\n\n/* --- Seletor de tipo de entrada (cards) --- */\n.unified-entry__types {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.unified-entry__type-card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  gap: 10px;\n  min-height: 140px;\n  padding: 18px 14px 20px;\n  border: 1.5px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  background: var(--ui-surface);\n  cursor: pointer;\n  text-align: center;\n  font-family: inherit;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease, background 0.15s ease;\n}\n\n.unified-entry__type-card:hover {\n  border-color: var(--ui-primary);\n  box-shadow: var(--ui-shadow-sm);\n  transform: translateY(-2px);\n}\n\n.unified-entry__type-card.is-active {\n  border-color: var(--ui-primary);\n  background: linear-gradient(180deg, rgba(3, 78, 162, 0.06), rgba(3, 78, 162, 0.02));\n  box-shadow: var(--ui-shadow-md);\n}\n\n.unified-entry__type-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  width: 44px;\n  height: 44px;\n  min-width: 44px;\n  min-height: 44px;\n  max-width: 44px;\n  max-height: 44px;\n  flex-shrink: 0;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  background: var(--ui-input-bg);\n  color: var(--ui-primary);\n  overflow: hidden;\n}\n\n.unified-entry__type-icon svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.unified-entry__type-card.is-active .unified-entry__type-icon {\n  background: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n}\n\n.unified-entry__type-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--ui-text);\n  line-height: 1.25;\n  overflow-wrap: break-word;\n}\n\n.unified-entry__type-description {\n  font-size: 0.72rem;\n  font-weight: 400;\n  color: var(--ui-muted);\n  line-height: 1.3;\n  overflow-wrap: break-word;\n}\n\n/* --- Painel de conteúdo (aparece após escolher o tipo) --- */\n.unified-entry__panel {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-sm);\n  padding: 24px;\n  animation: unified-entry-fade-in 0.2s ease;\n}\n\n@keyframes unified-entry-fade-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.unified-entry__hint {\n  font-size: 0.85rem;\n  color: var(--ui-muted);\n  margin: 0 0 12px;\n}\n\n.unified-entry__hint--error {\n  color: var(--Vermelho, #ef4123);\n}\n\n.unified-entry__notice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  margin-bottom: 18px;\n  border-radius: var(--ui-radius-sm);\n  background: var(--amarelo3, #fff4de);\n  color: #8a5a00;\n  font-size: 0.85rem;\n}\n\n.unified-entry__notice svg {\n  flex-shrink: 0;\n}\n\n/* --- Busca por CPF (retorno simples) --- */\n.unified-entry__search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.unified-entry__search-icon {\n  position: absolute;\n  left: 14px;\n  color: var(--ui-muted);\n  pointer-events: none;\n}\n\n/* `input[type]` (em vez de só `input`) pra ganhar em especificidade do seletor global\n   `input[type=\"text\"] { padding: 12px 14px; ... }` de src/index.css — com só `.classe input`\n   as duas regras empatam em especificidade e quem ganha vira uma loteria da ordem de import. */\n.unified-entry__search input[type] {\n  width: 100%;\n  padding: 12px 40px;\n  border-radius: var(--ui-radius-md);\n  border: 1.5px solid var(--ui-border);\n  background: var(--ui-input-bg);\n  font-size: 0.95rem;\n}\n\n.unified-entry__search input[type]:focus {\n  outline: none;\n  border-color: var(--ui-primary);\n}\n\n.unified-entry__search input[type]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.unified-entry__or {\n  text-align: center;\n  font-size: 0.75rem;\n  color: var(--ui-muted);\n  margin: -6px 0 12px;\n}\n\n.unified-entry__spinner,\n.unified-entry__spinner-inline {\n  width: 14px;\n  height: 14px;\n  border: 2px solid var(--ui-border);\n  border-top-color: var(--ui-primary);\n  border-radius: 50%;\n  animation: unified-entry-spin 0.7s linear infinite;\n}\n\n.unified-entry__spinner {\n  position: absolute;\n  right: 14px;\n}\n\n.unified-entry__spinner-inline {\n  display: inline-block;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n@keyframes unified-entry-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* --- Cartão do interno encontrado --- */\n.unified-entry__found {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: var(--ui-radius-md);\n  background: var(--ui-input-bg);\n  margin-bottom: 18px;\n}\n\n.unified-entry__avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n  font-weight: 700;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n.unified-entry__found-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n}\n\n.unified-entry__found-info strong {\n  color: var(--ui-text);\n  font-size: 0.95rem;\n}\n\n.unified-entry__found-info span {\n  color: var(--ui-muted);\n  font-size: 0.8rem;\n}\n\n.unified-entry__found-check {\n  color: var(--verde);\n  font-size: 1.1rem;\n}\n\n/* --- Grid de campos --- */\n.unified-entry__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.unified-entry__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  position: relative;\n}\n\n.unified-entry__field--full {\n  grid-column: 1 / -1;\n}\n\n.unified-entry__field label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--ui-muted);\n}\n\n.unified-entry__required {\n  color: var(--Vermelho, #ef4123);\n  margin-left: 2px;\n}\n\n.unified-entry__field input[type],\n.unified-entry__field select,\n.unified-entry__field textarea {\n  padding: 10px 12px;\n  border-radius: var(--ui-radius-sm);\n  border: 1.5px solid var(--ui-border);\n  background: var(--ui-input-bg);\n  font-size: 0.9rem;\n  font-family: inherit;\n  color: var(--ui-text);\n  transition: border-color 0.15s ease;\n}\n\n.unified-entry__field input[type]:focus,\n.unified-entry__field select:focus,\n.unified-entry__field textarea:focus {\n  outline: none;\n  border-color: var(--ui-primary);\n}\n\n.unified-entry__field select:disabled,\n.unified-entry__field input[type]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.unified-entry__field textarea {\n  min-height: 70px;\n  resize: vertical;\n}\n\n/* --- Autocomplete (nacionalidade/naturalidade) --- */\n.unified-entry__field--autocomplete {\n  position: relative;\n}\n\n.unified-entry__suggestions {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 20;\n  list-style: none;\n  margin: 0;\n  padding: 6px;\n  max-height: 190px;\n  overflow-y: auto;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-sm);\n  box-shadow: var(--ui-shadow-md);\n}\n\n.unified-entry__suggestions li {\n  padding: 8px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.unified-entry__suggestions li:hover {\n  background: var(--ui-input-bg);\n  color: var(--ui-primary);\n}\n\n/* --- Toggle Sim/Não --- */\n.unified-entry__toggle {\n  display: inline-flex;\n  border-radius: var(--ui-radius-sm);\n  border: 1.5px solid var(--ui-border);\n  overflow: hidden;\n  width: fit-content;\n}\n\n.unified-entry__toggle button {\n  padding: 9px 18px;\n  border: none;\n  background: var(--ui-input-bg);\n  color: var(--ui-muted);\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.unified-entry__toggle button + button {\n  border-left: 1.5px solid var(--ui-border);\n}\n\n.unified-entry__toggle button.is-active {\n  background: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n}\n\n/* --- Seções (wizard) --- */\n.unified-entry__section {\n  margin-bottom: 22px;\n  padding-top: 18px;\n  border-top: 1px solid var(--ui-border);\n}\n\n.unified-entry__section:first-of-type {\n  padding-top: 0;\n  border-top: none;\n}\n\n.unified-entry__section h3 {\n  margin: 0 0 14px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ui-primary);\n}\n\n/* --- Stepper --- */\n.unified-entry__stepper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 26px;\n}\n\n.unified-entry__step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.unified-entry__step-dot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--ui-input-bg);\n  border: 1.5px solid var(--ui-border);\n  color: var(--ui-muted);\n  font-size: 0.8rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.unified-entry__step.is-active .unified-entry__step-dot {\n  background: var(--ui-primary);\n  border-color: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n}\n\n.unified-entry__step.is-done .unified-entry__step-dot {\n  background: var(--verde);\n  border-color: var(--verde);\n  color: var(--branco);\n}\n\n.unified-entry__step-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--ui-muted);\n  white-space: nowrap;\n}\n\n.unified-entry__step.is-active .unified-entry__step-label {\n  color: var(--ui-text);\n}\n\n.unified-entry__step-line {\n  flex: 1;\n  height: 2px;\n  background: var(--ui-border);\n  margin: 0 8px;\n  min-width: 16px;\n}\n\n.unified-entry__step-line.is-done {\n  background: var(--verde);\n}\n\n/* --- Foto de perfil / upload --- */\n.unified-entry__photo-row {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-bottom: 22px;\n}\n\n.unified-entry__photo {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px dashed var(--ui-border);\n  background: var(--ui-input-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease;\n}\n\n.unified-entry__photo:hover {\n  border-color: var(--ui-primary);\n}\n\n.unified-entry__photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.unified-entry__photo-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  color: var(--ui-muted);\n  font-size: 0.7rem;\n  text-align: center;\n  padding: 8px;\n}\n\n.unified-entry__photo-placeholder svg {\n  font-size: 1.4rem;\n  color: var(--ui-primary);\n}\n\n.unified-entry__photo-hint {\n  color: var(--ui-muted);\n  font-size: 0.85rem;\n  max-width: 320px;\n}\n\n.unified-entry__webcam {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--azul-escuro);\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.unified-entry__webcam video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.unified-entry__photo-actions {\n  position: absolute;\n  bottom: 6px;\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  justify-content: center;\n  z-index: 2;\n}\n\n.unified-entry__photo-actions button {\n  font-size: 0.6rem;\n  padding: 4px 6px;\n}\n\n/* Upload da ficha assinada: retangular, não circular */\n.unified-entry__upload-zone {\n  position: relative;\n  width: 100%;\n  min-height: 180px;\n  border-radius: var(--ui-radius-md);\n  border: 2px dashed var(--ui-border);\n  background: var(--ui-input-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.15s ease;\n}\n\n.unified-entry__upload-zone:hover {\n  border-color: var(--ui-primary);\n}\n\n.unified-entry__upload-zone img {\n  width: 100%;\n  max-height: 260px;\n  object-fit: contain;\n}\n\n.unified-entry__upload-zone .unified-entry__webcam {\n  border-radius: var(--ui-radius-md);\n}\n\n.unified-entry__upload-zone .unified-entry__photo-placeholder svg {\n  font-size: 1.8rem;\n}\n\n/* Sobrescreve a regra global `form { display: flex; flex-wrap: wrap; }` de src/index.css —\n   sem isso, as seções do formulário viram itens de um flex que quebra linha, e o botão de\n   ação (que não tem largura própria) acaba \"sobrando\" ao lado do último campo em vez de ficar\n   numa linha só pra ele, embaixo de tudo. */\n.unified-entry__form {\n  display: block;\n}\n\n/* --- Botões --- */\n.unified-entry__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.unified-entry__btn-primary,\n.unified-entry__btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 22px;\n  border-radius: var(--ui-radius-sm);\n  font-size: 0.85rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1.5px solid transparent;\n  transition: filter 0.15s ease, background 0.15s ease;\n}\n\n.unified-entry__btn-primary {\n  background: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n}\n\n.unified-entry__btn-primary:hover:not(:disabled) {\n  filter: brightness(1.08);\n}\n\n.unified-entry__btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.unified-entry__btn-secondary {\n  background: var(--ui-surface);\n  color: var(--ui-text);\n  border-color: var(--ui-border);\n}\n\n.unified-entry__btn-secondary:hover:not(:disabled) {\n  border-color: var(--ui-primary);\n  color: var(--ui-primary);\n}\n\n@media (max-width: 640px) {\n  .unified-entry__panel {\n    padding: 16px;\n  }\n\n  .unified-entry__photo-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .unified-entry__stepper {\n    flex-wrap: wrap;\n    row-gap: 10px;\n  }\n}\n\n.internals-summary-badges {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 8px;\n}\n\n.internals-summary-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 14px;\n  border-radius: var(--ui-radius-md);\n  border: 1px solid transparent;\n  line-height: 1.4;\n}\n\n.internals-summary-badge strong {\n  font-weight: 800;\n}\n\n.internals-summary-badge-count {\n  color: #2b3a55;\n  background: #f7f9fe;\n  border-color: #e1e8f6;\n}\n\n.internals-summary-badge-vagas {\n  color: #15803d;\n  background: #dcfce7;\n  border-color: #bbf7d0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
